// Felületi fordítások: magyar, angol, német, kínai.
//
// HATÓKÖR: a felület (menük, gombok, pénztár, üzenetek). A TERMÉKNEVEK és
// -leírások magyarul maradnak — 1875 termék gépi fordítása rossz minőségű
// szakmai szöveget adna. A termékfordítások később a katalógusba tehetők
// (pl. product.i18n.en.name), a szerkezet ezt nem akadályozza.

export const LANGUAGES = [
  { code: 'hu', label: 'Magyar', flag: '🇭🇺' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', label: '中文', flag: '🇨🇳' }
];

export const DEFAULT_LANG = 'hu';

export const TRANSLATIONS = {
  hu: {
    'nav.all': 'Összes',
    'nav.blog': 'Blog',
    'nav.favorites': 'Kedvencek',
    'nav.cart': 'Kosár',
    'nav.search': 'Keresés névre vagy cikkszámra…',
    'nav.freeShipping': 'Ingyenes szállítás 30.000 Ft felett',

    'hero.title': 'A munkád megvéd minket. Mi megvédünk téged.',
    'hero.subtitle': 'Eredeti Portwest munkaruházat és védőfelszerelés, raktárról, országos kiszállítással.',
    'hero.ctaDeals': 'Akciós ajánlatok',
    'hero.ctaCategories': 'Kategóriák',

    'section.deals': 'Akciós ajánlatok',
    'section.belowList': 'Listaár alatt',
    'section.categories': 'Mit keresel?',
    'section.products': 'termék',
    'section.loadMore': 'Továbbiak betöltése',

    'filter.title': 'Szűrők',
    'filter.price': 'Ár',
    'filter.brand': 'Márka',
    'filter.size': 'Méret',
    'filter.rating': 'Értékelés',
    'filter.reset': 'Szűrők visszaállítása',
    'filter.sort': 'Rendezés',
    'filter.sortDefault': 'Alapértelmezett',
    'filter.sortPriceAsc': 'Ár: növekvő',
    'filter.sortPriceDesc': 'Ár: csökkenő',
    'filter.sortName': 'Név szerint',
    'filter.sortRating': 'Értékelés szerint',

    'product.addToCart': 'Kosárba',
    'product.inStock': 'Raktáron',
    'product.outOfStock': 'Elfogyott',
    'product.size': 'Méret',
    'product.color': 'Szín',
    'product.quantity': 'Mennyiség',
    'product.sizeChart': 'Mérettáblázat',
    'product.related': 'Hasonló termékek',
    'product.brand': 'Márka',

    'cart.title': 'Kosár',
    'cart.empty': 'A kosarad üres',
    'cart.subtotal': 'Részösszeg',
    'cart.shipping': 'Szállítás',
    'cart.total': 'Összesen',
    'cart.checkout': 'Rendelés lezárása',
    'cart.free': 'INGYENES',

    'checkout.title': 'Rendelés lezárása',
    'checkout.summary': 'Rendelési összesítő',
    'checkout.shippingData': 'Szállítási adatok',
    'checkout.name': 'Név',
    'checkout.email': 'E-mail',
    'checkout.phone': 'Telefon',
    'checkout.company': 'Cég/Szervezet',
    'checkout.address': 'Szállítási cím',
    'checkout.city': 'Város',
    'checkout.zip': 'Irányítószám',
    'checkout.shippingMethod': 'Szállítási mód',
    'checkout.homeDelivery': 'Házhozszállítás',
    'checkout.paymentMethod': 'Fizetési mód',
    'checkout.cod': 'Utánvét',
    'checkout.transfer': 'Előreutalás',
    'checkout.card': 'Bankkártya',
    'checkout.coupon': 'Kuponkód',
    'checkout.apply': 'Beváltás',
    'checkout.submit': 'Megrendelés elküldése',

    'account.title': 'Fiókom',
    'account.login': 'Bejelentkezés',
    'account.register': 'Regisztráció',
    'account.logout': 'Kijelentkezés',
    'account.myOrders': 'Rendeléseim',
    'account.password': 'Jelszó',

    'tracking.title': 'Rendeléskövetés',
    'tracking.orderId': 'Rendelésazonosító',
    'tracking.lookup': 'Rendelés lekérdezése',

    'footer.categories': 'Kategóriák',
    'footer.info': 'Információ',
    'footer.faq': 'Gyakori kérdések',
    'footer.tracking': 'Rendeléskövetés',
    'footer.account': 'Fiókom',
    'footer.about': 'Rólunk',
    'footer.shipping': 'Szállítási feltételek',
    'footer.terms': 'ÁSZF',
    'footer.privacy': 'Adatvédelem',
    'footer.impressum': 'Impresszum',
    'footer.contact': 'Kapcsolat',
    'footer.newsletter': 'Hírlevél',
    'footer.subscribe': 'Feliratkozom',

    'common.back': 'Vissza a webshopra',
    'common.loading': 'Betöltés…',
    'common.close': 'Bezárás',
    'common.productsInHungarian': 'A termékleírások magyar nyelvűek.',

    'cat.munkaruha': 'Munkaruházat',
    'cat.munkacipo': 'Munkavédelmi Cipők',
    'cat.bakancs': 'Bakancsok & Csizmák',
    'cat.kesztyu': 'Munkavédelmi Kesztyűk',
    'cat.kiegeszitok': 'Védőeszközök',

    'sub.nadragok': 'Munkanadrágok',
    'sub.felsok': 'Pólók, ingek & blúzok',
    'sub.puloverek': 'Pulóverek',
    'sub.kabatok': 'Kabátok & Dzsekik',
    'sub.lathatosagi': 'Jól láthatósági ruházat',
    'sub.overalok': 'Overálok',
    'sub.langallo': 'Lángálló munkaruha',
    'sub.esd-ruhazat': 'ESD munkaruha',
    'sub.eso-elleni': 'Eső elleni ruházat',
    'sub.hutohazi': 'Hűtőházi munkaruha',
    'sub.ipari-vedoruha': 'Ipari védőruha',
    'sub.kopeny-tunika': 'Köpenyek & Tunikák',
    'sub.elelmiszeripari': 'Élelmiszeripari ruházat',
    'sub.egyszer-hasznalatos': 'Egyszer használatos',
    'sub.sef-ruhazat': 'Séf munkaruházat',
    'sub.gyermek': 'Gyermek ruházat',
    'sub.cipo-s1': 'S1 / S1P kategória',
    'sub.cipo-s2s3': 'S2 / S3 kategória',
    'sub.szandal-papucs': 'Szandálok & Papucsok',
    'sub.zokni-talpbetet': 'Zoknik & Talpbetétek',
    'sub.bakancs-s1p': 'S1P bakancsok',
    'sub.bakancs-s3': 'S3 bakancsok',
    'sub.bakancs-teli': 'Téli bakancsok',
    'sub.csizmak': 'Gumicsizmák',
    'sub.kesztyu-mechanikai': 'Mechanikai védelem',
    'sub.kesztyu-vagasbiztos': 'Vágásbiztos',
    'sub.kesztyu-hideg': 'Hideg ellen',
    'sub.sisakok': 'Sisakok',
    'sub.arcvedok': 'Arcvédők',
    'sub.sapkak': 'Sapkák',
    'sub.szemuvegek': 'Védőszemüvegek',
    'sub.gumipantos-szemuvegek': 'Gumipántos (zárt) szemüvegek',
    'sub.mellenyek': 'Jól láthatósági mellények',
    'sub.fultokok': 'Fültokok',
    'sub.fuldugok': 'Füldugók',
    'sub.legzesvedok': 'Légzésvédők & Szűrők',
    'sub.terdvedok': 'Térdvédők',
    'sub.magasban-munka': 'Magasban munkavégzés',
    'sub.zuhanasgatlo-kieg': 'Zuhanásgátló kiegészítők',
    'sub.taskak': 'Táskák & Kiegészítők',

    'nav.home': 'Főoldal',
    'badge.sale': 'AKCIÓ',
    'badge.last': 'Utolsó {n} db!',
    'chip.winter': 'Téli',
    'chip.springAutumn': 'Tavaszi–őszi',
    'chip.summer': 'Nyári',
    'chip.multiColor': 'Több színben',
    'chip.bigSizes': 'Nagy méretekben is',
    'product.stockLine': 'Raktáron · 2-3 munkanap',
    'product.addWish': 'Kedvencekhez',
    'product.removeWish': 'Eltávolítás kedvencekből',
    'product.inStockCount': 'Raktáron: {n} db',
    'product.allSizesOut': 'Ebből a színből minden méret elfogyott.',
    'product.fullPage': 'Részletes termékoldal',
    'alert.chooseSize': 'Kérjük, válassz méretet!',
    'alert.chooseColor': 'Kérjük, válassz színt!',
    'alert.validEmail': 'Kérlek, érvényes email-címet adj meg.',
    'hero.saleKicker': 'AKCIÓ',
    'hero.upTo': 'AKÁR −{p}%',
    'hero.discountWord': 'KEDVEZMÉNY.',
    'hero.saleText': '{name} — most {price} Ft, amíg a készlet tart.',
    'hero.saleCta': 'Akciók megnézése',
    'hero.bogoTitle1': 'VEGYÉL KETTŐT,',
    'hero.bogoTitle2': 'FIZESS EGYET.',
    'hero.bogoText': 'Kesztyű, füldugó, védőszemüveg és maszk — minden 2. darab valóban ingyenes.',
    'hero.bogoCta': '1+1 ajánlatok',
    'hero.shipKicker': 'SZÁLLÍTÁS',
    'hero.shipTitle1': 'INGYENES SZÁLLÍTÁS',
    'hero.shipTitle2': '30 000 FT FELETT.',
    'hero.shipText': '100% eredeti Portwest termékek CE-tanúsítvánnyal, 14 napos csere és visszaküldés.',
    'section.dealsKicker': 'Most',
    'section.dealsSub': 'Válogatott kedvezmények, amíg a készlet tart.',
    'section.moreProducts': 'további termék',
    'mission.title': 'A HAMISÍTVÁNY NEM VÉD.',
    'mission.sub': 'NÁLUNK NINCS UTÁNZAT — EREDETI, CE-TANÚSÍTVÁNNYAL RENDELKEZŐ TERMÉKEK.',
    'bogo.kicker': 'Kettő az ár fele',
    'bogo.title': '1+1 Ajánlataink',
    'bogo.sub': 'Vegyél kettőt, fizess egyet — a kedvezmény a kosárban és a számlán is valós.',
    'bogo.perPcNormal': 'Ft/db normál áron',
    'bogo.perPcDeal': '/db 1+1-gyel',
    'bogo.addTwo': '2 db kosárba',
    'noResults.title': 'Nincs találat',
    'noResults.text': 'Próbálj más szűrési feltételeket vagy állítsd vissza a szűrőket!',
    'filter.show': 'Szűrők megjelenítése',
    'filter.hide': 'Szűrők elrejtése',
    'filter.industry': 'Iparág',
    'filter.standard': 'Szabvány',
    'filter.all': 'Mind',
    'trust.ship': 'Gyors Kiszállítás',
    'trust.shipText': '2-3 munkanapon belül országosan',
    'trust.quality': 'Minőségi Garancia',
    'trust.qualityText': 'EU tanúsított termékek',
    'trust.expert': 'Szakértő Tanácsadás',
    'trust.expertText': 'Szakértő segítség a választáshoz',
    'trust.support': 'Ügyfélszolgálat',
    'blog.kicker': 'Szakértői tartalom',
    'blog.title': 'Hasznos bejegyzések',
    'blog.all': 'Összes cikk →',
    'blog.read': 'Tovább olvasom →',
    'blog.minRead': 'perc olvasás',
    'blog.defaultTag': 'Szakmai tudás',
    'news.heading': 'Iratkozz fel, hogy segíthessünk a tökéletes választásban!',
    'news.b1': 'Az aktuális akciókat elsőként nálunk éred el',
    'news.b2': 'Szezonális ajánlatok és vásárlási tippek egy helyen',
    'news.b3': 'Havonta max. 2 email, bármikor leiratkozhatsz',
    'news.emailPh': 'Email-címed',
    'footer.desc': 'Munkavédelmi ruházat, cipők és felszerelések közvetlenül raktárról.',
    'footer.blog': 'Blog',
    'footer.wishlist': 'Kedvenceim',
    'footer.rights': 'Minden jog fenntartva',
    'pdp.reviews': 'Értékelések',
    'pdp.reviewSummary': 'Értékelés-összegzés',
    'pdp.clickToFilter': 'Kattints egy sorra a szűréshez.',
    'pdp.stars': '{n} csillag',
    'pdp.overallRating': 'Összesített értékelés',
    'pdp.noReviews': 'Még nincs értékelés — legyél te az első!',
    'pdp.rateProduct': 'Értékeld a terméket',
    'pdp.moderated': 'Az értékeléseket moderáljuk — jóváhagyás után jelennek meg.',
    'pdp.writeReview': 'Írd meg a véleményed',
    'pdp.yourName': 'Neved',
    'pdp.reviewPh': 'Milyen a termék? Méret, kényelem, tartósság…',
    'pdp.submitReview': 'Értékelés beküldése',
    'pdp.chooseColor': 'Válassz színt',
    'pdp.chooseSize': 'Válassz méretet',
    'pdp.shipBoxTitle': 'Szállítás, csere és visszaküldés',
    'pdp.shipInfo1': 'Kiszállítás 2-3 munkanapon belül országosan, 30 000 Ft felett ingyenesen.',
    'pdp.shipInfo2': '14 napon belül indoklás nélkül cserélheted vagy visszaküldheted a terméket.',
    'pdp.trust1': 'Gyors kiszállítás 2-3 munkanap',
    'pdp.trust2': 'EU tanúsított termék',
    'pdp.trust3': '14 napos visszavásárlási garancia',

    'cart.bundleLine': '1+1 Akció — minden 2. darab ingyenes',
    'cart.freePcs': '({n} db ingyen)',
    'nav.allCat': 'Összes {name} →',
    'filter.subcategories': 'Alkategóriák',
    'tile.kabatok': 'Kabátok',
    'tile.polok': 'Pólók',
    'tile.nadragok': 'Nadrágok',
    'tile.cipok': 'Munkavédelmi Cipők',
    'tile.bakancsok': 'Munkavédelmi Bakancsok',
    'tile.kesztyuk': 'Munkavédelmi Kesztyűk',
    'tile.vedoeszkozok': 'Védőeszközök',
    'tile.egyebek': 'Egyebek',
    'ind.food': 'Élelmiszeripar',
    'ind.esd': 'ESD & elektronika',
    'ind.cold': 'Hűtőházi & hidegtárolás',
    'ind.industrial': 'Ipari védelem',
    'ind.welding': 'Hegesztés & tűzvédelem',
    'ind.hospitality': 'Vendéglátás & séf',
    'ind.height': 'Magasban végzett munka',
    'ind.construction': 'Építőipar & közúti munka',
    'news.done': 'Feliratkoztál, köszönjük!',
    'hero.t1': 'A MUNKÁD MEGVÉD MINKET.',
    'hero.t2': 'MI MEGVÉDÜNK TÉGED.',
    'hero.countText': '{n}+ eredeti Portwest munkaruha, védőcipő és felszerelés.',
    'alert.sizeOut': 'A(z) {color} színből {size} méretben elfogyott!',
    'alert.sizeOnly': 'A(z) {color} / {size} méretből csak {n} db van raktáron!',
    'pdp.reviewWord': 'értékelés',
    'pdp.inWishlist': 'Kedvencekben',
    'pdp.sortTop': 'Legjobb értékelés elöl',
    'pdp.sortNew': 'Legújabb elöl',
    'pdp.noFilteredReviews': 'Nincs a szűrőnek megfelelő értékelés.',
    'pdp.reviewThanks': 'Köszönjük! Az értékelésed jóváhagyás után jelenik meg.',
    'pdp.reviewMissing': 'Kérlek, add meg a neved és a véleményed!',

    'checkout.emptyTitle': 'A kosár üres!',
    'checkout.emptyText': 'Adj hozzá termékeket a kosárhoz, hogy rendelhess.',
    'checkout.backToCatalog': 'Vissza a termékkatalógushoz',
    'checkout.successTitle': 'Rendelés sikeresen elküldve!',
    'checkout.successText1': 'Köszönjük a rendelésedért! A(z) {email} email címre elküldtük a rendelés részleteit.',
    'checkout.successText2': 'Rövid időn belül felveszik veled a kapcsolatot.',
    'checkout.backHome': 'Vissza a főoldalra',
    'checkout.couponPlaceholder': 'pl. NYAR10',
    'checkout.remove': 'Törlés',
    'checkout.couponApplied': '{code} kupon beváltva',
    'checkout.productsTotal': 'Termékek összesen:',
    'checkout.couponDiscount': 'Kupon kedvezmény ({code}):',
    'checkout.grandTotal': 'Végösszesen:',
    'checkout.namePlaceholder': 'Teljes neved',
    'checkout.emailPlaceholder': 'email@example.com',
    'checkout.marketingConsent': 'Feliratkozom a hírlevélre (akciók, kuponok — havonta max. 2 email), és kérek emlékeztetőt, ha itt hagyom a kosaram. Bármikor leiratkozhatsz.',
    'checkout.phonePlaceholder': '+36 30 123 4567',
    'checkout.companyPlaceholder': 'Cég neve (opcionális)',
    'checkout.addressPlaceholder': 'Utca, házszám',
    'checkout.cityPlaceholder': 'Város',
    'checkout.zipPlaceholder': '1000',
    'checkout.homeDeliveryDays': '2-3 munkanap',
    'checkout.foxpost': 'Foxpost automata',
    'checkout.foxpostDays': '2-4 munkanap',
    'checkout.foxpostLoadingList': '(lista betöltése…)',
    'checkout.foxpostChange': 'Módosítás',
    'checkout.foxpostSearchPlaceholder': 'Keresés város vagy irányítószám szerint…',
    'checkout.codDesc': 'Készpénz vagy kártya a futárnál / az automatánál',
    'checkout.transferDesc': 'A visszaigazoló e-mailben küldjük az utalási adatokat',
    'checkout.cardDesc': 'Azonnali, biztonságos fizetés a SimplePay felületén',
    'checkout.transferNote': 'A csomagot az összeg beérkezése után adjuk fel.',
    'checkout.cardNote': 'A „Megrendelés elküldése" után a SimplePay biztonságos oldalára irányítunk. Kártyaadataidat a webshop nem látja és nem tárolja.',
    'checkout.notesLabel': 'Megjegyzések (opcionális)',
    'checkout.notesPlaceholder': 'Speciális utasítások, kívánságok...',
    'checkout.submitting': 'Feldolgozás...',
    'checkout.paymentNote': 'Fizetés: A rendelés után e-mailben fogjuk küldeni a fizetési adatokat.',
    'checkout.errRequired': 'Kérjük, töltsd ki az összes kötelező mezőt!',
    'checkout.errEmptyCart': 'A kosár üres!',
    'checkout.errFoxpost': 'Kérjük, válassz Foxpost automatát!',
    'checkout.errGeneric': 'Hiba történt a rendelés feldolgozásakor. Kérjük, próbáld újra később!',
    'checkout.errCardFailed': 'A bankkártyás fizetés indítása nem sikerült. A rendelésed rögzítettük — az utalási adatokat e-mailben küldjük.',
    'checkout.errCoupon': 'Érvénytelen kupon',
    'checkout.errCouponCheck': 'Kupon-ellenőrzési hiba, próbáld újra!',

    'account.notAvailable': 'A vásárlói fiókok jelenleg nem érhetők el.',
    'account.noOrders': 'Még nincs rendelésed ezzel az e-mail-címmel.',
    'account.goToShop': 'Irány a webshop',
    'account.invoiceLabel': 'Számla',
    'account.trackingLabel': 'Csomagszám',
    'account.invoiceNote': 'A számlát minden rendelésről e-mailben küldjük. Ha nem találod, írj a(z) {email} címre.',
    'account.resetHeading': 'Elfelejtett jelszó',
    'account.loginSubtitle': 'Jelentkezz be a korábbi rendeléseid megtekintéséhez.',
    'account.registerSubtitle': 'Hozz létre fiókot, hogy nyomon követhesd a rendeléseidet és számláidat.',
    'account.resetSubtitle': 'Add meg az e-mail-címed, és küldünk egy jelszó-visszaállító linket.',
    'account.name': 'Név',
    'account.namePlaceholder': 'Teljes neved',
    'account.email': 'E-mail-cím',
    'account.emailPlaceholder': 'email@example.com',
    'account.passwordPlaceholder': 'Legalább 6 karakter',
    'account.working': 'Folyamatban…',
    'account.submitRegister': 'Fiók létrehozása',
    'account.submitReset': 'Visszaállító link kérése',
    'account.noAccountYet': 'Még nincs fiókom',
    'account.forgotPassword': 'Elfelejtettem a jelszavam',
    'account.backToLogin': 'Vissza a bejelentkezéshez',
    'account.guestNote1': 'Fiók nélkül is tudsz vásárolni. A rendelésed állapotát a ',
    'account.guestNoteLink': 'rendeléskövetőben',
    'account.guestNote2': ' is megnézheted.',
    'account.registerSuccess': 'Sikeres regisztráció! Ha megerősítő levelet kaptál, kattints a benne lévő linkre.',
    'account.resetSuccess': 'Elküldtük a jelszó-visszaállító levelet. Nézd meg a postafiókod!',
    'account.genericError': 'Hiba történt.',
    'account.loadError': 'Betöltési hiba',

    'status.pending': 'Feldolgozás alatt',
    'status.paid': 'Fizetve',
    'status.packed': 'Csomagolva',
    'status.shipped': 'Úton',
    'status.delivered': 'Kézbesítve',
    'status.cancelled': 'Lemondva',

    'tracking.subtitle': 'Add meg a rendelésazonosítót (a visszaigazoló e-mailben találod) és az e-mail-címet, amivel rendeltél.',
    'tracking.emailLabel': 'E-mail-cím',
    'tracking.orderIdPlaceholder': 'pl. ORD-1784992520497',
    'tracking.emailPlaceholder': 'email@example.com',
    'tracking.searching': 'Keresés…',
    'tracking.errRequired': 'Add meg a rendelésazonosítót és az e-mail-címet.',
    'tracking.errNotFound': 'Nem sikerült lekérni a rendelést.',
    'tracking.errNetwork': 'Hálózati hiba. Ellenőrizd a kapcsolatot és próbáld újra.',
    'tracking.cancelled': 'Ez a rendelés le lett mondva.',
    'tracking.total': 'Végösszeg',
    'tracking.trackingNumber': 'Csomagszám:',
    'tracking.trackingNote': 'Ezzel a számmal a futárszolgálat oldalán is nyomon követheted a csomagot.',
    'tracking.items': 'Tételek',
    'tracking.shippingLabel': 'Szállítás:',
    'tracking.paymentLabel': 'Fizetés:',
    'tracking.invoiceLabel': 'Számlaszám:',
    'tracking.foxpost': 'Foxpost automata',
    'tracking.helpTitle': 'Nem találod a rendelésed?',
    'tracking.step.pending': 'Beérkezett',
    'tracking.step.paid': 'Fizetve',
    'tracking.step.packed': 'Csomagolva',
    'tracking.step.shipped': 'Feladva',
    'tracking.step.delivered': 'Kézbesítve',

    'common.callUs': 'Hívj minket:',

    'wishlist.count': '{n} mentett termék',
    'wishlist.cloudTitle': 'Kedvencek mentése email-címhez — így bármelyik eszközödről elérheted',
    'wishlist.cloudSubtitle': 'A listát egy általad választott PIN-kód védi. Ugyanezzel a PIN-nel tudod visszatölteni.',
    'wishlist.emailPlaceholder': 'email@cimed.hu',
    'wishlist.pinPlaceholder': 'PIN (4-8 számjegy)',
    'wishlist.save': 'Mentés',
    'wishlist.load': 'Betöltés',
    'wishlist.errEmail': 'Adj meg érvényes email címet!',
    'wishlist.errPin': 'Adj meg egy 4-8 számjegyű PIN-kódot — ez védi a listádat.',
    'wishlist.errGeneric': 'Hiba történt, próbáld újra!',
    'wishlist.savedMsg': '{n} kedvenc elmentve. Jegyezd meg a PIN-t — ezzel töltheted vissza!',
    'wishlist.loadedMsg': '{n} kedvenc betöltve',
    'wishlist.emptyTitle': 'Nincs még kedvenced',
    'wishlist.emptyText': 'A termékkártyán a ❤️ ikonra kattintva mentheted el a kedvenceidet!',
    'wishlist.backToProducts': 'Vissza a termékekhez',

    'nf.title': 'Ez az oldal nincs meg',
    'nf.text': 'Lehet, hogy elírtad a címet, vagy a keresett termék már nem elérhető. A teljes kínálatunk — több mint 1 800 munkavédelmi termék — egy kattintásra van.',
    'nf.backShop': 'Vissza a webshopba',
    'nf.browseCategories': 'Kategóriák böngészése',
    'nf.helpText': 'Segítsünk megtalálni, amit keresel?',

    'blog.heading': 'Szakértői blog',
    'blog.subtitle': 'Útmutatók, szabvány-magyarázatok és vásárlási tanácsok — hogy pontosan azt vedd meg, amire tényleg szükséged van.',
    'blog.allCount': 'Összes ({n})',
    'blog.noResults': 'Nincs a szűrésnek megfelelő cikk.',
    'blog.latest': 'Legfrissebb',
    'blog.min': 'perc',
    'blog.webshop': 'Webshop',
    'blog.summary': 'Röviden:',
    'blog.recoTitle': 'A cikkhez ajánljuk',
    'blog.recoSubtitle': 'Válogatás a webshopból — listaár alatti árakkal.',
    'blog.toShop': 'Tovább a webshopba',
    'blog.relatedArticles': 'Kapcsolódó cikkek',
    'blog.authorBio': 'A TridentShop a Trident Shield Group Kft. webáruháza — munkavédelmi szakemberek válogatják a termékeket és írják az útmutatókat. Kérdésed van? Hívj:',

    'faq.heading': 'Gyakori kérdések',
    'faq.subtitle': 'Összegyűjtöttük a leggyakoribb kérdéseket a rendelésről, szállításról és a munkavédelmi termékek kiválasztásáról.',
    'faq.helpTitle': 'Nem találod a választ?',
    'faq.q1': 'Mennyi a szállítási idő és a szállítási költség?',
    'faq.a1': 'Rendelésedet 2-3 munkanapon belül kézbesítjük országosan futárszolgálattal (1 290 Ft), vagy 2-4 munkanapon belül Foxpost csomagautomatába (990 Ft). 30 000 Ft feletti rendelésnél a kiszállítás mindkét módon ingyenes.',
    'faq.q2': 'Milyen munkavédelmi cipő kategóriát válasszak (S1, S1P, S2, S3)?',
    'faq.a2': 'Az S1 beltéri, száraz környezetbe való (orrmerevítő + antisztatikus talp). Az S1P átszúrás elleni talplemezt is tartalmaz — műhelybe, építkezésre. Az S2 vízálló felsőrészt ad, az S3 pedig mindezt együtt: vízálló, átszúrásbiztos, profilos talpú — kültéri és ipari munkához ezt ajánljuk. Részletes útmutató a blogunkban található.',
    'faq.q3': 'Ki fizeti a munkavédelmi eszközöket: a munkáltató vagy a dolgozó?',
    'faq.a3': 'A munkavédelmi törvény szerint az egyéni védőeszközt a munkáltató köteles biztosítani, saját költségén. A védőeszköz-juttatás rendjét 2024-től írásban kell rögzíteni munkakörönként. Cégünk, a Trident Shield Group Kft. ebben szolgáltatásként is segít.',
    'faq.q4': 'Hogyan válasszak méretet?',
    'faq.a4': 'Lábbeliknél a megszokott utcai méretedet válaszd; téli, vastag zoknis viselethez fél számmal nagyobbat. Ruházatnál a Portwest európai méretezést használ (S-4XL) — kétség esetén a termékoldalon lévő méretek közül a nagyobbat ajánljuk. Ha nem jó a méret, cseréljük.',
    'faq.q5': 'Vissza tudom küldeni vagy cserélni a terméket?',
    'faq.a5': 'Igen, a hatályos fogyasztóvédelmi szabályok szerint 14 napon belül indoklás nélkül elállhatsz a vásárlástól, a terméket pedig cseréljük vagy visszatérítjük az árát. A részleteket az ÁSZF tartalmazza.',
    'faq.q6': 'Kapok számlát a rendelésről?',
    'faq.a6': 'Igen, minden rendelésről áfás számlát állítunk ki (cégeknek céges adatokkal), amelyet a rendelés visszaigazolásával együtt küldünk.',
    'faq.q7': 'Nagyobb tételben, céges beszerzésként is rendelhetek?',
    'faq.a7': 'Természetesen — céges és intézményi megrendeléseket is kiszolgálunk, nagyobb tételnél egyedi árajánlatot adunk. Írj az iroda@tuz-munkavedelmiszaki.hu címre vagy hívd a +36 30 272 2571 számot.',
    'faq.q8': 'Eredeti Portwest termékeket forgalmaztok?',
    'faq.a8': 'Igen, kizárólag eredeti, CE minősítésű Portwest termékeket értékesítünk hivatalos magyarországi beszállítói háttérrel. Minden termék megfelel a vonatkozó EU-szabványoknak (pl. EN ISO 20345 lábbelik, EN 388 kesztyűk, EN ISO 20471 láthatósági ruházat, EN 397 sisakok).',
    'faq.q9': 'Hol található az üzletetek?',
    'faq.a9': 'Központunk: 4030 Debrecen, Keleti Ipartelep utca 4. A webshopból az egész országba szállítunk. Nyitvatartás: hétfő-péntek 8:00-17:00.',
    'faq.q10': 'Munkavédelmi szolgáltatásokat is nyújtotok?',
    'faq.a10': 'Igen — a Trident Shield Group Kft. (MunkavédelmiSzaki) teljes körű munkavédelmi és tűzvédelmi szolgáltatást nyújt: kockázatértékelés, munkavédelmi oktatás, tűzvédelmi szabályzat és egyéni védőeszköz juttatási rend készítése magyar KKV-knak.'
  },

  en: {
    'nav.all': 'All',
    'nav.blog': 'Blog',
    'nav.favorites': 'Favourites',
    'nav.cart': 'Cart',
    'nav.search': 'Search by name or item number…',
    'nav.freeShipping': 'Free shipping over 30,000 Ft',

    'hero.title': 'Your work protects us. We protect you.',
    'hero.subtitle': 'Genuine Portwest workwear and protective equipment, in stock, delivered nationwide.',
    'hero.ctaDeals': 'Special offers',
    'hero.ctaCategories': 'Categories',

    'section.deals': 'Special offers',
    'section.belowList': 'Below list price',
    'section.categories': 'What are you looking for?',
    'section.products': 'products',
    'section.loadMore': 'Load more',

    'filter.title': 'Filters',
    'filter.price': 'Price',
    'filter.brand': 'Brand',
    'filter.size': 'Size',
    'filter.rating': 'Rating',
    'filter.reset': 'Reset filters',
    'filter.sort': 'Sort',
    'filter.sortDefault': 'Default',
    'filter.sortPriceAsc': 'Price: low to high',
    'filter.sortPriceDesc': 'Price: high to low',
    'filter.sortName': 'By name',
    'filter.sortRating': 'By rating',

    'product.addToCart': 'Add to cart',
    'product.inStock': 'In stock',
    'product.outOfStock': 'Out of stock',
    'product.size': 'Size',
    'product.color': 'Colour',
    'product.quantity': 'Quantity',
    'product.sizeChart': 'Size chart',
    'product.related': 'Related products',
    'product.brand': 'Brand',

    'cart.title': 'Cart',
    'cart.empty': 'Your cart is empty',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.total': 'Total',
    'cart.checkout': 'Checkout',
    'cart.free': 'FREE',

    'checkout.title': 'Checkout',
    'checkout.summary': 'Order summary',
    'checkout.shippingData': 'Shipping details',
    'checkout.name': 'Name',
    'checkout.email': 'Email',
    'checkout.phone': 'Phone',
    'checkout.company': 'Company',
    'checkout.address': 'Shipping address',
    'checkout.city': 'City',
    'checkout.zip': 'Postal code',
    'checkout.shippingMethod': 'Shipping method',
    'checkout.homeDelivery': 'Home delivery',
    'checkout.paymentMethod': 'Payment method',
    'checkout.cod': 'Cash on delivery',
    'checkout.transfer': 'Bank transfer',
    'checkout.card': 'Card payment',
    'checkout.coupon': 'Coupon code',
    'checkout.apply': 'Apply',
    'checkout.submit': 'Place order',

    'account.title': 'My account',
    'account.login': 'Sign in',
    'account.register': 'Sign up',
    'account.logout': 'Sign out',
    'account.myOrders': 'My orders',
    'account.password': 'Password',

    'tracking.title': 'Order tracking',
    'tracking.orderId': 'Order ID',
    'tracking.lookup': 'Track order',

    'footer.categories': 'Categories',
    'footer.info': 'Information',
    'footer.faq': 'FAQ',
    'footer.tracking': 'Order tracking',
    'footer.account': 'My account',
    'footer.about': 'About us',
    'footer.shipping': 'Shipping',
    'footer.terms': 'Terms & Conditions',
    'footer.privacy': 'Privacy policy',
    'footer.impressum': 'Imprint',
    'footer.contact': 'Contact',
    'footer.newsletter': 'Newsletter',
    'footer.subscribe': 'Subscribe',

    'common.back': 'Back to shop',
    'common.loading': 'Loading…',
    'common.close': 'Close',
    'common.productsInHungarian': 'Product descriptions are in Hungarian.',

    'cat.munkaruha': 'Workwear',
    'cat.munkacipo': 'Safety Shoes',
    'cat.bakancs': 'Safety Boots & Wellingtons',
    'cat.kesztyu': 'Safety Gloves',
    'cat.kiegeszitok': 'Protective Equipment',

    'sub.nadragok': 'Work Trousers',
    'sub.felsok': 'T-shirts, Shirts & Blouses',
    'sub.puloverek': 'Sweatshirts & Jumpers',
    'sub.kabatok': 'Jackets & Coats',
    'sub.lathatosagi': 'Hi-Vis Clothing',
    'sub.overalok': 'Coveralls',
    'sub.langallo': 'Flame Resistant Workwear',
    'sub.esd-ruhazat': 'ESD Workwear',
    'sub.eso-elleni': 'Rainwear',
    'sub.hutohazi': 'Cold Store Workwear',
    'sub.ipari-vedoruha': 'Industrial Protective Clothing',
    'sub.kopeny-tunika': 'Coats & Tunics',
    'sub.elelmiszeripari': 'Food Industry Clothing',
    'sub.egyszer-hasznalatos': 'Disposable Clothing',
    'sub.sef-ruhazat': 'Chef Wear',
    'sub.gyermek': "Kids' Clothing",
    'sub.cipo-s1': 'S1 / S1P category',
    'sub.cipo-s2s3': 'S2 / S3 category',
    'sub.szandal-papucs': 'Sandals & Clogs',
    'sub.zokni-talpbetet': 'Socks & Insoles',
    'sub.bakancs-s1p': 'S1P Boots',
    'sub.bakancs-s3': 'S3 Boots',
    'sub.bakancs-teli': 'Winter Boots',
    'sub.csizmak': 'Wellington Boots',
    'sub.kesztyu-mechanikai': 'Mechanical Protection',
    'sub.kesztyu-vagasbiztos': 'Cut Resistant',
    'sub.kesztyu-hideg': 'Cold Protection',
    'sub.sisakok': 'Safety Helmets',
    'sub.arcvedok': 'Face Shields',
    'sub.sapkak': 'Bump Caps & Hats',
    'sub.szemuvegek': 'Safety Glasses',
    'sub.gumipantos-szemuvegek': 'Safety Goggles',
    'sub.mellenyek': 'Hi-Vis Vests',
    'sub.fultokok': 'Ear Defenders',
    'sub.fuldugok': 'Ear Plugs',
    'sub.legzesvedok': 'Respirators & Filters',
    'sub.terdvedok': 'Knee Pads',
    'sub.magasban-munka': 'Working at Height',
    'sub.zuhanasgatlo-kieg': 'Fall Arrest Accessories',
    'sub.taskak': 'Bags & Accessories',

    'nav.home': 'Home',
    'badge.sale': 'SALE',
    'badge.last': 'Only {n} left!',
    'chip.winter': 'Winter',
    'chip.springAutumn': 'Spring–Autumn',
    'chip.summer': 'Summer',
    'chip.multiColor': 'Multiple colours',
    'chip.bigSizes': 'Big sizes available',
    'product.stockLine': 'In stock · 2-3 working days',
    'product.addWish': 'Add to favourites',
    'product.removeWish': 'Remove from favourites',
    'product.inStockCount': 'In stock: {n} pcs',
    'product.allSizesOut': 'All sizes of this colour are sold out.',
    'product.fullPage': 'Full product page',
    'alert.chooseSize': 'Please choose a size!',
    'alert.chooseColor': 'Please choose a colour!',
    'alert.validEmail': 'Please enter a valid email address.',
    'hero.saleKicker': 'SALE',
    'hero.upTo': 'UP TO −{p}%',
    'hero.discountWord': 'OFF.',
    'hero.saleText': '{name} — now {price} Ft, while stocks last.',
    'hero.saleCta': 'See offers',
    'hero.bogoTitle1': 'BUY TWO,',
    'hero.bogoTitle2': 'PAY FOR ONE.',
    'hero.bogoText': 'Gloves, ear plugs, safety glasses and masks — every 2nd item is genuinely free.',
    'hero.bogoCta': '1+1 offers',
    'hero.shipKicker': 'SHIPPING',
    'hero.shipTitle1': 'FREE SHIPPING',
    'hero.shipTitle2': 'OVER 30,000 FT.',
    'hero.shipText': '100% genuine Portwest products with CE certification, 14-day exchange and returns.',
    'section.dealsKicker': 'Now',
    'section.dealsSub': 'Selected discounts, while stocks last.',
    'section.moreProducts': 'more products',
    'mission.title': "FAKES DON'T PROTECT.",
    'mission.sub': 'NO IMITATIONS HERE — GENUINE, CE-CERTIFIED PRODUCTS.',
    'bogo.kicker': 'Two for half the price',
    'bogo.title': 'Our 1+1 Offers',
    'bogo.sub': 'Buy two, pay for one — the discount is real in your cart and on your invoice.',
    'bogo.perPcNormal': 'Ft/pc at normal price',
    'bogo.perPcDeal': '/pc with 1+1',
    'bogo.addTwo': 'Add 2 to cart',
    'noResults.title': 'No results',
    'noResults.text': 'Try different filters or reset them!',
    'filter.show': 'Show filters',
    'filter.hide': 'Hide filters',
    'filter.industry': 'Industry',
    'filter.standard': 'Standard',
    'filter.all': 'All',
    'trust.ship': 'Fast Delivery',
    'trust.shipText': 'Nationwide within 2-3 working days',
    'trust.quality': 'Quality Guarantee',
    'trust.qualityText': 'EU certified products',
    'trust.expert': 'Expert Advice',
    'trust.expertText': 'Expert help with your choice',
    'trust.support': 'Customer Service',
    'blog.kicker': 'Expert content',
    'blog.title': 'Useful articles',
    'blog.all': 'All articles →',
    'blog.read': 'Read more →',
    'blog.minRead': 'min read',
    'blog.defaultTag': 'Expertise',
    'news.heading': 'Subscribe and let us help you make the perfect choice!',
    'news.b1': 'Be the first to hear about current offers',
    'news.b2': 'Seasonal offers and buying tips in one place',
    'news.b3': 'Max. 2 emails a month, unsubscribe anytime',
    'news.emailPh': 'Your email address',
    'footer.desc': 'Safety workwear, footwear and equipment straight from stock.',
    'footer.blog': 'Blog',
    'footer.wishlist': 'My favourites',
    'footer.rights': 'All rights reserved',
    'pdp.reviews': 'Reviews',
    'pdp.reviewSummary': 'Rating summary',
    'pdp.clickToFilter': 'Click a row to filter.',
    'pdp.stars': '{n} stars',
    'pdp.overallRating': 'Overall rating',
    'pdp.noReviews': 'No reviews yet — be the first!',
    'pdp.rateProduct': 'Rate this product',
    'pdp.moderated': 'Reviews are moderated — they appear after approval.',
    'pdp.writeReview': 'Write a review',
    'pdp.yourName': 'Your name',
    'pdp.reviewPh': 'How is the product? Size, comfort, durability…',
    'pdp.submitReview': 'Submit review',
    'pdp.chooseColor': 'Choose a colour',
    'pdp.chooseSize': 'Choose a size',
    'pdp.shipBoxTitle': 'Shipping, exchange & returns',
    'pdp.shipInfo1': 'Delivery nationwide within 2-3 working days, free over 30,000 Ft.',
    'pdp.shipInfo2': 'Exchange or return the product within 14 days, no questions asked.',
    'pdp.trust1': 'Fast delivery in 2-3 working days',
    'pdp.trust2': 'EU certified product',
    'pdp.trust3': '14-day money-back guarantee',

    'cart.bundleLine': '1+1 deal — every 2nd item free',
    'cart.freePcs': '({n} pcs free)',
    'nav.allCat': 'All {name} →',
    'filter.subcategories': 'Subcategories',
    'tile.kabatok': 'Jackets',
    'tile.polok': 'T-shirts',
    'tile.nadragok': 'Trousers',
    'tile.cipok': 'Safety Shoes',
    'tile.bakancsok': 'Safety Boots',
    'tile.kesztyuk': 'Safety Gloves',
    'tile.vedoeszkozok': 'Protective Equipment',
    'tile.egyebek': 'Other',
    'ind.food': 'Food industry',
    'ind.esd': 'ESD & electronics',
    'ind.cold': 'Cold store & refrigeration',
    'ind.industrial': 'Industrial protection',
    'ind.welding': 'Welding & fire protection',
    'ind.hospitality': 'Hospitality & chef',
    'ind.height': 'Working at height',
    'ind.construction': 'Construction & road work',
    'news.done': 'Subscribed, thank you!',
    'hero.t1': 'YOUR WORK PROTECTS US.',
    'hero.t2': 'WE PROTECT YOU.',
    'hero.countText': '{n}+ genuine Portwest workwear items, safety footwear and equipment.',
    'alert.sizeOut': 'Colour {color} in size {size} is sold out!',
    'alert.sizeOnly': 'Only {n} pcs left of {color} / size {size}!',
    'pdp.reviewWord': 'reviews',
    'pdp.inWishlist': 'In favourites',
    'pdp.sortTop': 'Top rated first',
    'pdp.sortNew': 'Newest first',
    'pdp.noFilteredReviews': 'No reviews match the filter.',
    'pdp.reviewThanks': 'Thank you! Your review will appear after approval.',
    'pdp.reviewMissing': 'Please enter your name and your review!',

    'checkout.emptyTitle': 'Your cart is empty!',
    'checkout.emptyText': 'Add products to your cart to place an order.',
    'checkout.backToCatalog': 'Back to the product catalogue',
    'checkout.successTitle': 'Order successfully placed!',
    'checkout.successText1': "Thank you for your order! We've sent the order details to {email}.",
    'checkout.successText2': 'We will contact you shortly.',
    'checkout.backHome': 'Back to homepage',
    'checkout.couponPlaceholder': 'e.g. SUMMER10',
    'checkout.remove': 'Remove',
    'checkout.couponApplied': 'Coupon {code} applied',
    'checkout.productsTotal': 'Products total:',
    'checkout.couponDiscount': 'Coupon discount ({code}):',
    'checkout.grandTotal': 'Grand total:',
    'checkout.namePlaceholder': 'Your full name',
    'checkout.emailPlaceholder': 'email@example.com',
    'checkout.marketingConsent': "I subscribe to the newsletter (offers, coupons — max. 2 emails a month), and I'd like a reminder if I leave items in my cart. You can unsubscribe anytime.",
    'checkout.phonePlaceholder': '+36 30 123 4567',
    'checkout.companyPlaceholder': 'Company name (optional)',
    'checkout.addressPlaceholder': 'Street, house number',
    'checkout.cityPlaceholder': 'City',
    'checkout.zipPlaceholder': '1000',
    'checkout.homeDeliveryDays': '2-3 working days',
    'checkout.foxpost': 'Foxpost parcel locker',
    'checkout.foxpostDays': '2-4 working days',
    'checkout.foxpostLoadingList': '(loading list…)',
    'checkout.foxpostChange': 'Change',
    'checkout.foxpostSearchPlaceholder': 'Search by city or postal code…',
    'checkout.codDesc': 'Cash or card at the courier / locker',
    'checkout.transferDesc': "We'll send the transfer details in the confirmation email",
    'checkout.cardDesc': 'Instant, secure payment via SimplePay',
    'checkout.transferNote': 'We ship the package once the payment has been received.',
    'checkout.cardNote': 'After clicking "Place order" you\'ll be redirected to SimplePay\'s secure page. The webshop never sees or stores your card details.',
    'checkout.notesLabel': 'Notes (optional)',
    'checkout.notesPlaceholder': 'Special instructions, requests...',
    'checkout.submitting': 'Processing...',
    'checkout.paymentNote': "Payment: We'll email you the payment details after your order.",
    'checkout.errRequired': 'Please fill in all required fields!',
    'checkout.errEmptyCart': 'The cart is empty!',
    'checkout.errFoxpost': 'Please choose a Foxpost locker!',
    'checkout.errGeneric': 'An error occurred while processing your order. Please try again later!',
    'checkout.errCardFailed': "We couldn't start the card payment. Your order has been recorded — we'll email you the transfer details.",
    'checkout.errCoupon': 'Invalid coupon',
    'checkout.errCouponCheck': 'Coupon check failed, please try again!',

    'account.notAvailable': 'Customer accounts are currently unavailable.',
    'account.noOrders': "You don't have any orders yet with this email address.",
    'account.goToShop': 'Go to the shop',
    'account.invoiceLabel': 'Invoice',
    'account.trackingLabel': 'Tracking number',
    'account.invoiceNote': "We email the invoice for every order. If you can't find it, write to {email}.",
    'account.resetHeading': 'Forgot password',
    'account.loginSubtitle': 'Sign in to view your previous orders.',
    'account.registerSubtitle': 'Create an account to keep track of your orders and invoices.',
    'account.resetSubtitle': "Enter your email address and we'll send you a password reset link.",
    'account.name': 'Name',
    'account.namePlaceholder': 'Your full name',
    'account.email': 'Email address',
    'account.emailPlaceholder': 'email@example.com',
    'account.passwordPlaceholder': 'At least 6 characters',
    'account.working': 'Working…',
    'account.submitRegister': 'Create account',
    'account.submitReset': 'Request reset link',
    'account.noAccountYet': "I don't have an account yet",
    'account.forgotPassword': 'I forgot my password',
    'account.backToLogin': 'Back to sign in',
    'account.guestNote1': 'You can also shop without an account. You can check your order status on the ',
    'account.guestNoteLink': 'order tracking page',
    'account.guestNote2': ' too.',
    'account.registerSuccess': 'Registration successful! If you received a confirmation email, click the link inside it.',
    'account.resetSuccess': "We've sent the password reset email. Check your inbox!",
    'account.genericError': 'An error occurred.',
    'account.loadError': 'Loading error',

    'status.pending': 'Processing',
    'status.paid': 'Paid',
    'status.packed': 'Packed',
    'status.shipped': 'On the way',
    'status.delivered': 'Delivered',
    'status.cancelled': 'Cancelled',

    'tracking.subtitle': "Enter the order ID (you'll find it in the confirmation email) and the email address you ordered with.",
    'tracking.emailLabel': 'Email address',
    'tracking.orderIdPlaceholder': 'e.g. ORD-1784992520497',
    'tracking.emailPlaceholder': 'email@example.com',
    'tracking.searching': 'Searching…',
    'tracking.errRequired': 'Enter the order ID and the email address.',
    'tracking.errNotFound': "We couldn't retrieve your order.",
    'tracking.errNetwork': 'Network error. Check your connection and try again.',
    'tracking.cancelled': 'This order has been cancelled.',
    'tracking.total': 'Total',
    'tracking.trackingNumber': 'Tracking number:',
    'tracking.trackingNote': "You can also track the package with this number on the courier's website.",
    'tracking.items': 'Items',
    'tracking.shippingLabel': 'Shipping:',
    'tracking.paymentLabel': 'Payment:',
    'tracking.invoiceLabel': 'Invoice number:',
    'tracking.foxpost': 'Foxpost parcel locker',
    'tracking.helpTitle': "Can't find your order?",
    'tracking.step.pending': 'Received',
    'tracking.step.paid': 'Paid',
    'tracking.step.packed': 'Packed',
    'tracking.step.shipped': 'Shipped',
    'tracking.step.delivered': 'Delivered',

    'common.callUs': 'Call us:',

    'wishlist.count': '{n} saved products',
    'wishlist.cloudTitle': 'Save favourites to your email address — access them from any device',
    'wishlist.cloudSubtitle': 'The list is protected by a PIN code of your choice. Use the same PIN to load it back.',
    'wishlist.emailPlaceholder': 'your@email.com',
    'wishlist.pinPlaceholder': 'PIN (4-8 digits)',
    'wishlist.save': 'Save',
    'wishlist.load': 'Load',
    'wishlist.errEmail': 'Please enter a valid email address!',
    'wishlist.errPin': 'Enter a 4-8 digit PIN — this protects your list.',
    'wishlist.errGeneric': 'An error occurred, please try again!',
    'wishlist.savedMsg': "{n} favourites saved. Remember your PIN — you'll need it to load them back!",
    'wishlist.loadedMsg': '{n} favourites loaded',
    'wishlist.emptyTitle': "You don't have any favourites yet",
    'wishlist.emptyText': 'Click the ❤️ icon on a product card to save your favourites!',
    'wishlist.backToProducts': 'Back to products',

    'nf.title': "This page can't be found",
    'nf.text': "You may have mistyped the address, or the product you're looking for is no longer available. Our full range — over 1,800 safety products — is just a click away.",
    'nf.backShop': 'Back to the shop',
    'nf.browseCategories': 'Browse categories',
    'nf.helpText': "Can we help you find what you're looking for?",

    'blog.heading': 'Expert blog',
    'blog.subtitle': "Guides, standards explained, and buying tips — so you get exactly what you actually need.",
    'blog.allCount': 'All ({n})',
    'blog.noResults': 'No articles match this filter.',
    'blog.latest': 'Latest',
    'blog.min': 'min',
    'blog.webshop': 'Shop',
    'blog.summary': 'In short:',
    'blog.recoTitle': 'Recommended for this article',
    'blog.recoSubtitle': 'A selection from our shop — at below list-price prices.',
    'blog.toShop': 'Continue to the shop',
    'blog.relatedArticles': 'Related articles',
    'blog.authorBio': 'TridentShop is the online shop of Trident Shield Group Kft. — occupational safety experts select the products and write the guides. Got a question? Call:',

    'faq.heading': 'Frequently asked questions',
    'faq.subtitle': "We've collected the most common questions about ordering, shipping, and choosing safety products.",
    'faq.helpTitle': "Can't find the answer?",
    'faq.q1': 'How long does shipping take and how much does it cost?',
    'faq.a1': 'We deliver your order nationwide within 2-3 working days by courier (1,290 Ft), or within 2-4 working days to a Foxpost parcel locker (990 Ft). For orders over 30,000 Ft, delivery is free either way.',
    'faq.q2': 'Which safety footwear category should I choose (S1, S1P, S2, S3)?',
    'faq.a2': "S1 is for indoor, dry environments (toe cap + antistatic sole). S1P also includes a puncture-resistant midsole — for workshops and construction sites. S2 adds a water-resistant upper, while S3 combines everything: water-resistant, puncture-resistant, cleated sole — we recommend this for outdoor and industrial work. You'll find a detailed guide on our blog.",
    'faq.q3': 'Who pays for personal protective equipment: the employer or the employee?',
    'faq.a3': 'Under Hungarian occupational safety law, the employer is required to provide personal protective equipment at its own expense. Since 2024, the PPE allocation policy must be recorded in writing for each job role. Our company, Trident Shield Group Kft., also offers this as a service.',
    'faq.q4': 'How do I choose the right size?',
    'faq.a4': "For footwear, choose your usual street shoe size; for winter wear with thick socks, go half a size up. For clothing, Portwest uses European sizing (S-4XL) — if in doubt, we recommend choosing the larger of the available sizes on the product page. If the size doesn't fit, we'll exchange it.",
    'faq.q5': 'Can I return or exchange a product?',
    'faq.a5': "Yes, under current consumer protection rules you can withdraw from the purchase within 14 days without giving a reason, and we'll exchange the product or refund its price. Details are in our Terms & Conditions.",
    'faq.q6': 'Will I receive an invoice for my order?',
    'faq.a6': 'Yes, we issue a VAT invoice for every order (with company details for businesses), which we send together with the order confirmation.',
    'faq.q7': 'Can I order in bulk as a business purchase?',
    'faq.a7': 'Of course — we also serve corporate and institutional orders, and we provide a custom quote for larger volumes. Write to iroda@tuz-munkavedelmiszaki.hu or call +36 30 272 2571.',
    'faq.q8': 'Do you sell genuine Portwest products?',
    'faq.a8': 'Yes, we sell exclusively genuine, CE-certified Portwest products backed by an official Hungarian supplier. Every product complies with the relevant EU standards (e.g. EN ISO 20345 footwear, EN 388 gloves, EN ISO 20471 hi-vis clothing, EN 397 helmets).',
    'faq.q9': 'Where is your store located?',
    'faq.a9': 'Our headquarters: 4030 Debrecen, Keleti Ipartelep utca 4, Hungary. We ship nationwide from our webshop. Opening hours: Monday-Friday 8:00-17:00.',
    'faq.q10': 'Do you also offer occupational safety services?',
    'faq.a10': 'Yes — Trident Shield Group Kft. (MunkavédelmiSzaki) provides comprehensive occupational safety and fire protection services: risk assessments, safety training, fire safety regulations, and personal protective equipment allocation policies for Hungarian SMEs.'
  },

  de: {
    'nav.all': 'Alle',
    'nav.blog': 'Blog',
    'nav.favorites': 'Favoriten',
    'nav.cart': 'Warenkorb',
    'nav.search': 'Suche nach Name oder Artikelnummer…',
    'nav.freeShipping': 'Kostenloser Versand ab 30.000 Ft',

    'hero.title': 'Deine Arbeit schützt uns. Wir schützen dich.',
    'hero.subtitle': 'Original Portwest Arbeitskleidung und Schutzausrüstung, ab Lager, landesweite Lieferung.',
    'hero.ctaDeals': 'Angebote',
    'hero.ctaCategories': 'Kategorien',

    'section.deals': 'Angebote',
    'section.belowList': 'Unter Listenpreis',
    'section.categories': 'Was suchst du?',
    'section.products': 'Produkte',
    'section.loadMore': 'Mehr laden',

    'filter.title': 'Filter',
    'filter.price': 'Preis',
    'filter.brand': 'Marke',
    'filter.size': 'Größe',
    'filter.rating': 'Bewertung',
    'filter.reset': 'Filter zurücksetzen',
    'filter.sort': 'Sortieren',
    'filter.sortDefault': 'Standard',
    'filter.sortPriceAsc': 'Preis: aufsteigend',
    'filter.sortPriceDesc': 'Preis: absteigend',
    'filter.sortName': 'Nach Name',
    'filter.sortRating': 'Nach Bewertung',

    'product.addToCart': 'In den Warenkorb',
    'product.inStock': 'Auf Lager',
    'product.outOfStock': 'Ausverkauft',
    'product.size': 'Größe',
    'product.color': 'Farbe',
    'product.quantity': 'Menge',
    'product.sizeChart': 'Größentabelle',
    'product.related': 'Ähnliche Produkte',
    'product.brand': 'Marke',

    'cart.title': 'Warenkorb',
    'cart.empty': 'Dein Warenkorb ist leer',
    'cart.subtotal': 'Zwischensumme',
    'cart.shipping': 'Versand',
    'cart.total': 'Gesamt',
    'cart.checkout': 'Zur Kasse',
    'cart.free': 'KOSTENLOS',

    'checkout.title': 'Zur Kasse',
    'checkout.summary': 'Bestellübersicht',
    'checkout.shippingData': 'Lieferdaten',
    'checkout.name': 'Name',
    'checkout.email': 'E-Mail',
    'checkout.phone': 'Telefon',
    'checkout.company': 'Firma',
    'checkout.address': 'Lieferadresse',
    'checkout.city': 'Stadt',
    'checkout.zip': 'Postleitzahl',
    'checkout.shippingMethod': 'Versandart',
    'checkout.homeDelivery': 'Hauslieferung',
    'checkout.paymentMethod': 'Zahlungsart',
    'checkout.cod': 'Nachnahme',
    'checkout.transfer': 'Vorkasse',
    'checkout.card': 'Kartenzahlung',
    'checkout.coupon': 'Gutscheincode',
    'checkout.apply': 'Einlösen',
    'checkout.submit': 'Bestellung abschicken',

    'account.title': 'Mein Konto',
    'account.login': 'Anmelden',
    'account.register': 'Registrieren',
    'account.logout': 'Abmelden',
    'account.myOrders': 'Meine Bestellungen',
    'account.password': 'Passwort',

    'tracking.title': 'Sendungsverfolgung',
    'tracking.orderId': 'Bestellnummer',
    'tracking.lookup': 'Bestellung suchen',

    'footer.categories': 'Kategorien',
    'footer.info': 'Informationen',
    'footer.faq': 'Häufige Fragen',
    'footer.tracking': 'Sendungsverfolgung',
    'footer.account': 'Mein Konto',
    'footer.about': 'Über uns',
    'footer.shipping': 'Versand',
    'footer.terms': 'AGB',
    'footer.privacy': 'Datenschutz',
    'footer.impressum': 'Impressum',
    'footer.contact': 'Kontakt',
    'footer.newsletter': 'Newsletter',
    'footer.subscribe': 'Abonnieren',

    'common.back': 'Zurück zum Shop',
    'common.loading': 'Wird geladen…',
    'common.close': 'Schließen',
    'common.productsInHungarian': 'Die Produktbeschreibungen sind auf Ungarisch.',

    'cat.munkaruha': 'Arbeitskleidung',
    'cat.munkacipo': 'Sicherheitsschuhe',
    'cat.bakancs': 'Sicherheitsstiefel & Gummistiefel',
    'cat.kesztyu': 'Schutzhandschuhe',
    'cat.kiegeszitok': 'Schutzausrüstung',

    'sub.nadragok': 'Arbeitshosen',
    'sub.felsok': 'T-Shirts, Hemden & Blusen',
    'sub.puloverek': 'Pullover & Sweatshirts',
    'sub.kabatok': 'Jacken & Mäntel',
    'sub.lathatosagi': 'Warnschutzkleidung',
    'sub.overalok': 'Overalls',
    'sub.langallo': 'Flammhemmende Kleidung',
    'sub.esd-ruhazat': 'ESD-Kleidung',
    'sub.eso-elleni': 'Regenbekleidung',
    'sub.hutohazi': 'Kühlhauskleidung',
    'sub.ipari-vedoruha': 'Industrieschutzkleidung',
    'sub.kopeny-tunika': 'Kittel & Tuniken',
    'sub.elelmiszeripari': 'Lebensmittelkleidung',
    'sub.egyszer-hasznalatos': 'Einwegkleidung',
    'sub.sef-ruhazat': 'Kochbekleidung',
    'sub.gyermek': 'Kinderkleidung',
    'sub.cipo-s1': 'Kategorie S1 / S1P',
    'sub.cipo-s2s3': 'Kategorie S2 / S3',
    'sub.szandal-papucs': 'Sandalen & Clogs',
    'sub.zokni-talpbetet': 'Socken & Einlegesohlen',
    'sub.bakancs-s1p': 'S1P-Stiefel',
    'sub.bakancs-s3': 'S3-Stiefel',
    'sub.bakancs-teli': 'Winterstiefel',
    'sub.csizmak': 'Gummistiefel',
    'sub.kesztyu-mechanikai': 'Mechanischer Schutz',
    'sub.kesztyu-vagasbiztos': 'Schnittschutz',
    'sub.kesztyu-hideg': 'Kälteschutz',
    'sub.sisakok': 'Schutzhelme',
    'sub.arcvedok': 'Gesichtsschutz',
    'sub.sapkak': 'Anstoßkappen & Mützen',
    'sub.szemuvegek': 'Schutzbrillen',
    'sub.gumipantos-szemuvegek': 'Vollsichtbrillen',
    'sub.mellenyek': 'Warnwesten',
    'sub.fultokok': 'Kapselgehörschutz',
    'sub.fuldugok': 'Gehörschutzstöpsel',
    'sub.legzesvedok': 'Atemschutz & Filter',
    'sub.terdvedok': 'Knieschoner',
    'sub.magasban-munka': 'Höhenarbeit',
    'sub.zuhanasgatlo-kieg': 'Absturzsicherungszubehör',
    'sub.taskak': 'Taschen & Zubehör',

    'nav.home': 'Startseite',
    'badge.sale': 'AKTION',
    'badge.last': 'Nur noch {n} Stück!',
    'chip.winter': 'Winter',
    'chip.springAutumn': 'Übergangszeit',
    'chip.summer': 'Sommer',
    'chip.multiColor': 'Mehrere Farben',
    'chip.bigSizes': 'Auch in Übergrößen',
    'product.stockLine': 'Auf Lager · 2-3 Werktage',
    'product.addWish': 'Zu Favoriten',
    'product.removeWish': 'Aus Favoriten entfernen',
    'product.inStockCount': 'Auf Lager: {n} Stk.',
    'product.allSizesOut': 'In dieser Farbe sind alle Größen ausverkauft.',
    'product.fullPage': 'Zur Produktseite',
    'alert.chooseSize': 'Bitte wähle eine Größe!',
    'alert.chooseColor': 'Bitte wähle eine Farbe!',
    'alert.validEmail': 'Bitte gib eine gültige E-Mail-Adresse ein.',
    'hero.saleKicker': 'AKTION',
    'hero.upTo': 'BIS ZU −{p}%',
    'hero.discountWord': 'RABATT.',
    'hero.saleText': '{name} — jetzt {price} Ft, solange der Vorrat reicht.',
    'hero.saleCta': 'Angebote ansehen',
    'hero.bogoTitle1': 'ZWEI KAUFEN,',
    'hero.bogoTitle2': 'EINS BEZAHLEN.',
    'hero.bogoText': 'Handschuhe, Ohrstöpsel, Schutzbrillen und Masken — jedes 2. Stück ist wirklich gratis.',
    'hero.bogoCta': '1+1 Angebote',
    'hero.shipKicker': 'VERSAND',
    'hero.shipTitle1': 'KOSTENLOSER VERSAND',
    'hero.shipTitle2': 'AB 30.000 FT.',
    'hero.shipText': '100% Original-Portwest-Produkte mit CE-Zertifikat, 14 Tage Umtausch & Rückgabe.',
    'section.dealsKicker': 'Jetzt',
    'section.dealsSub': 'Ausgewählte Rabatte, solange der Vorrat reicht.',
    'section.moreProducts': 'weitere Produkte',
    'mission.title': 'FÄLSCHUNGEN SCHÜTZEN NICHT.',
    'mission.sub': 'BEI UNS KEINE IMITATE — ORIGINALE, CE-ZERTIFIZIERTE PRODUKTE.',
    'bogo.kicker': 'Zwei zum halben Preis',
    'bogo.title': 'Unsere 1+1 Angebote',
    'bogo.sub': 'Kauf zwei, zahl eins — der Rabatt gilt im Warenkorb und auf der Rechnung.',
    'bogo.perPcNormal': 'Ft/Stk. zum Normalpreis',
    'bogo.perPcDeal': '/Stk. mit 1+1',
    'bogo.addTwo': '2 Stk. in den Warenkorb',
    'noResults.title': 'Keine Treffer',
    'noResults.text': 'Versuche andere Filter oder setze sie zurück!',
    'filter.show': 'Filter anzeigen',
    'filter.hide': 'Filter ausblenden',
    'filter.industry': 'Branche',
    'filter.standard': 'Norm',
    'filter.all': 'Alle',
    'trust.ship': 'Schnelle Lieferung',
    'trust.shipText': 'Landesweit in 2-3 Werktagen',
    'trust.quality': 'Qualitätsgarantie',
    'trust.qualityText': 'EU-zertifizierte Produkte',
    'trust.expert': 'Fachberatung',
    'trust.expertText': 'Fachkundige Hilfe bei der Auswahl',
    'trust.support': 'Kundendienst',
    'blog.kicker': 'Experteninhalte',
    'blog.title': 'Nützliche Beiträge',
    'blog.all': 'Alle Artikel →',
    'blog.read': 'Weiterlesen →',
    'blog.minRead': 'Min. Lesezeit',
    'blog.defaultTag': 'Fachwissen',
    'news.heading': 'Abonniere unseren Newsletter — wir helfen dir bei der perfekten Wahl!',
    'news.b1': 'Erfahre als Erster von aktuellen Aktionen',
    'news.b2': 'Saisonale Angebote und Kauftipps an einem Ort',
    'news.b3': 'Max. 2 E-Mails pro Monat, jederzeit abbestellbar',
    'news.emailPh': 'Deine E-Mail-Adresse',
    'footer.desc': 'Arbeitsschutzkleidung, Schuhe und Ausrüstung direkt ab Lager.',
    'footer.blog': 'Blog',
    'footer.wishlist': 'Meine Favoriten',
    'footer.rights': 'Alle Rechte vorbehalten',
    'pdp.reviews': 'Bewertungen',
    'pdp.reviewSummary': 'Bewertungsübersicht',
    'pdp.clickToFilter': 'Klicke auf eine Zeile zum Filtern.',
    'pdp.stars': '{n} Sterne',
    'pdp.overallRating': 'Gesamtbewertung',
    'pdp.noReviews': 'Noch keine Bewertungen — sei der Erste!',
    'pdp.rateProduct': 'Produkt bewerten',
    'pdp.moderated': 'Bewertungen werden moderiert und erscheinen nach Freigabe.',
    'pdp.writeReview': 'Schreibe eine Bewertung',
    'pdp.yourName': 'Dein Name',
    'pdp.reviewPh': 'Wie ist das Produkt? Größe, Komfort, Haltbarkeit…',
    'pdp.submitReview': 'Bewertung absenden',
    'pdp.chooseColor': 'Farbe wählen',
    'pdp.chooseSize': 'Größe wählen',
    'pdp.shipBoxTitle': 'Versand, Umtausch & Rückgabe',
    'pdp.shipInfo1': 'Lieferung landesweit in 2-3 Werktagen, kostenlos ab 30.000 Ft.',
    'pdp.shipInfo2': 'Innerhalb von 14 Tagen ohne Angabe von Gründen umtauschen oder zurückgeben.',
    'pdp.trust1': 'Schnelle Lieferung in 2-3 Werktagen',
    'pdp.trust2': 'EU-zertifiziertes Produkt',
    'pdp.trust3': '14 Tage Geld-zurück-Garantie',

    'cart.bundleLine': '1+1 Aktion — jedes 2. Stück gratis',
    'cart.freePcs': '({n} Stk. gratis)',
    'nav.allCat': 'Alle {name} →',
    'filter.subcategories': 'Unterkategorien',
    'tile.kabatok': 'Jacken',
    'tile.polok': 'T-Shirts',
    'tile.nadragok': 'Hosen',
    'tile.cipok': 'Sicherheitsschuhe',
    'tile.bakancsok': 'Sicherheitsstiefel',
    'tile.kesztyuk': 'Schutzhandschuhe',
    'tile.vedoeszkozok': 'Schutzausrüstung',
    'tile.egyebek': 'Sonstiges',
    'ind.food': 'Lebensmittelindustrie',
    'ind.esd': 'ESD & Elektronik',
    'ind.cold': 'Kühlhaus & Kühllagerung',
    'ind.industrial': 'Industrieschutz',
    'ind.welding': 'Schweißen & Brandschutz',
    'ind.hospitality': 'Gastronomie & Koch',
    'ind.height': 'Höhenarbeit',
    'ind.construction': 'Bau & Straßenarbeit',
    'news.done': 'Abonniert, danke!',
    'hero.t1': 'DEINE ARBEIT SCHÜTZT UNS.',
    'hero.t2': 'WIR SCHÜTZEN DICH.',
    'hero.countText': '{n}+ originale Portwest Arbeitskleidung, Sicherheitsschuhe und Ausrüstung.',
    'alert.sizeOut': 'Farbe {color} in Größe {size} ist ausverkauft!',
    'alert.sizeOnly': 'Von {color} / Größe {size} sind nur noch {n} Stk. auf Lager!',
    'pdp.reviewWord': 'Bewertungen',
    'pdp.inWishlist': 'In Favoriten',
    'pdp.sortTop': 'Beste zuerst',
    'pdp.sortNew': 'Neueste zuerst',
    'pdp.noFilteredReviews': 'Keine Bewertungen entsprechen dem Filter.',
    'pdp.reviewThanks': 'Danke! Deine Bewertung erscheint nach Freigabe.',
    'pdp.reviewMissing': 'Bitte gib deinen Namen und deine Bewertung ein!',

    'checkout.emptyTitle': 'Dein Warenkorb ist leer!',
    'checkout.emptyText': 'Füge Produkte zum Warenkorb hinzu, um zu bestellen.',
    'checkout.backToCatalog': 'Zurück zum Produktkatalog',
    'checkout.successTitle': 'Bestellung erfolgreich abgeschickt!',
    'checkout.successText1': 'Danke für deine Bestellung! Wir haben die Bestelldetails an {email} gesendet.',
    'checkout.successText2': 'Wir melden uns in Kürze bei dir.',
    'checkout.backHome': 'Zurück zur Startseite',
    'checkout.couponPlaceholder': 'z. B. SOMMER10',
    'checkout.remove': 'Entfernen',
    'checkout.couponApplied': 'Gutschein {code} eingelöst',
    'checkout.productsTotal': 'Produkte gesamt:',
    'checkout.couponDiscount': 'Gutscheinrabatt ({code}):',
    'checkout.grandTotal': 'Gesamtsumme:',
    'checkout.namePlaceholder': 'Dein vollständiger Name',
    'checkout.emailPlaceholder': 'email@example.com',
    'checkout.marketingConsent': 'Ich abonniere den Newsletter (Aktionen, Gutscheine — max. 2 E-Mails pro Monat) und möchte eine Erinnerung, falls ich meinen Warenkorb verlasse. Du kannst dich jederzeit abmelden.',
    'checkout.phonePlaceholder': '+36 30 123 4567',
    'checkout.companyPlaceholder': 'Firmenname (optional)',
    'checkout.addressPlaceholder': 'Straße, Hausnummer',
    'checkout.cityPlaceholder': 'Stadt',
    'checkout.zipPlaceholder': '1000',
    'checkout.homeDeliveryDays': '2-3 Werktage',
    'checkout.foxpost': 'Foxpost-Paketautomat',
    'checkout.foxpostDays': '2-4 Werktage',
    'checkout.foxpostLoadingList': '(Liste wird geladen…)',
    'checkout.foxpostChange': 'Ändern',
    'checkout.foxpostSearchPlaceholder': 'Suche nach Stadt oder Postleitzahl…',
    'checkout.codDesc': 'Bar oder Karte beim Kurier / am Automaten',
    'checkout.transferDesc': 'Die Überweisungsdaten senden wir in der Bestätigungs-E-Mail',
    'checkout.cardDesc': 'Sofortige, sichere Zahlung über SimplePay',
    'checkout.transferNote': 'Wir versenden das Paket, sobald der Betrag eingegangen ist.',
    'checkout.cardNote': 'Nach „Bestellung abschicken" wirst du zur sicheren SimplePay-Seite weitergeleitet. Der Webshop sieht oder speichert deine Kartendaten nicht.',
    'checkout.notesLabel': 'Anmerkungen (optional)',
    'checkout.notesPlaceholder': 'Besondere Hinweise, Wünsche...',
    'checkout.submitting': 'Wird verarbeitet...',
    'checkout.paymentNote': 'Zahlung: Wir senden dir die Zahlungsdaten nach der Bestellung per E-Mail.',
    'checkout.errRequired': 'Bitte fülle alle Pflichtfelder aus!',
    'checkout.errEmptyCart': 'Der Warenkorb ist leer!',
    'checkout.errFoxpost': 'Bitte wähle einen Foxpost-Automaten!',
    'checkout.errGeneric': 'Bei der Bestellverarbeitung ist ein Fehler aufgetreten. Bitte versuche es später erneut!',
    'checkout.errCardFailed': 'Die Kartenzahlung konnte nicht gestartet werden. Deine Bestellung wurde erfasst — wir senden dir die Überweisungsdaten per E-Mail.',
    'checkout.errCoupon': 'Ungültiger Gutschein',
    'checkout.errCouponCheck': 'Fehler bei der Gutschein-Prüfung, bitte versuche es erneut!',

    'account.notAvailable': 'Kundenkonten sind derzeit nicht verfügbar.',
    'account.noOrders': 'Mit dieser E-Mail-Adresse liegen noch keine Bestellungen vor.',
    'account.goToShop': 'Zum Shop',
    'account.invoiceLabel': 'Rechnung',
    'account.trackingLabel': 'Sendungsnummer',
    'account.invoiceNote': 'Die Rechnung senden wir zu jeder Bestellung per E-Mail. Falls du sie nicht findest, schreibe an {email}.',
    'account.resetHeading': 'Passwort vergessen',
    'account.loginSubtitle': 'Melde dich an, um deine bisherigen Bestellungen einzusehen.',
    'account.registerSubtitle': 'Erstelle ein Konto, um deine Bestellungen und Rechnungen zu verfolgen.',
    'account.resetSubtitle': 'Gib deine E-Mail-Adresse ein, wir senden dir einen Link zum Zurücksetzen des Passworts.',
    'account.name': 'Name',
    'account.namePlaceholder': 'Dein vollständiger Name',
    'account.email': 'E-Mail-Adresse',
    'account.emailPlaceholder': 'email@example.com',
    'account.passwordPlaceholder': 'Mindestens 6 Zeichen',
    'account.working': 'Wird bearbeitet…',
    'account.submitRegister': 'Konto erstellen',
    'account.submitReset': 'Rücksetzlink anfordern',
    'account.noAccountYet': 'Ich habe noch kein Konto',
    'account.forgotPassword': 'Ich habe mein Passwort vergessen',
    'account.backToLogin': 'Zurück zur Anmeldung',
    'account.guestNote1': 'Du kannst auch ohne Konto einkaufen. Den Status deiner Bestellung kannst du auch in der ',
    'account.guestNoteLink': 'Sendungsverfolgung',
    'account.guestNote2': ' einsehen.',
    'account.registerSuccess': 'Registrierung erfolgreich! Falls du eine Bestätigungs-E-Mail erhalten hast, klicke auf den enthaltenen Link.',
    'account.resetSuccess': 'Wir haben die E-Mail zum Zurücksetzen des Passworts gesendet. Schau in dein Postfach!',
    'account.genericError': 'Ein Fehler ist aufgetreten.',
    'account.loadError': 'Ladefehler',

    'status.pending': 'In Bearbeitung',
    'status.paid': 'Bezahlt',
    'status.packed': 'Verpackt',
    'status.shipped': 'Unterwegs',
    'status.delivered': 'Zugestellt',
    'status.cancelled': 'Storniert',

    'tracking.subtitle': 'Gib die Bestellnummer ein (du findest sie in der Bestätigungs-E-Mail) und die E-Mail-Adresse, mit der du bestellt hast.',
    'tracking.emailLabel': 'E-Mail-Adresse',
    'tracking.orderIdPlaceholder': 'z. B. ORD-1784992520497',
    'tracking.emailPlaceholder': 'email@example.com',
    'tracking.searching': 'Suche läuft…',
    'tracking.errRequired': 'Gib die Bestellnummer und die E-Mail-Adresse ein.',
    'tracking.errNotFound': 'Die Bestellung konnte nicht abgerufen werden.',
    'tracking.errNetwork': 'Netzwerkfehler. Überprüfe deine Verbindung und versuche es erneut.',
    'tracking.cancelled': 'Diese Bestellung wurde storniert.',
    'tracking.total': 'Gesamtbetrag',
    'tracking.trackingNumber': 'Sendungsnummer:',
    'tracking.trackingNote': 'Mit dieser Nummer kannst du das Paket auch auf der Website des Kurierdienstes verfolgen.',
    'tracking.items': 'Positionen',
    'tracking.shippingLabel': 'Versand:',
    'tracking.paymentLabel': 'Zahlung:',
    'tracking.invoiceLabel': 'Rechnungsnummer:',
    'tracking.foxpost': 'Foxpost-Paketautomat',
    'tracking.helpTitle': 'Findest du deine Bestellung nicht?',
    'tracking.step.pending': 'Eingegangen',
    'tracking.step.paid': 'Bezahlt',
    'tracking.step.packed': 'Verpackt',
    'tracking.step.shipped': 'Versendet',
    'tracking.step.delivered': 'Zugestellt',

    'common.callUs': 'Ruf uns an:',

    'wishlist.count': '{n} gespeicherte Produkte',
    'wishlist.cloudTitle': 'Favoriten mit deiner E-Mail-Adresse speichern — so erreichst du sie von jedem Gerät',
    'wishlist.cloudSubtitle': 'Die Liste ist durch eine von dir gewählte PIN geschützt. Mit derselben PIN kannst du sie wieder laden.',
    'wishlist.emailPlaceholder': 'deine@email.de',
    'wishlist.pinPlaceholder': 'PIN (4-8 Ziffern)',
    'wishlist.save': 'Speichern',
    'wishlist.load': 'Laden',
    'wishlist.errEmail': 'Bitte gib eine gültige E-Mail-Adresse ein!',
    'wishlist.errPin': 'Gib eine 4-8-stellige PIN ein — sie schützt deine Liste.',
    'wishlist.errGeneric': 'Ein Fehler ist aufgetreten, bitte versuche es erneut!',
    'wishlist.savedMsg': '{n} Favoriten gespeichert. Merke dir die PIN — damit kannst du sie wieder laden!',
    'wishlist.loadedMsg': '{n} Favoriten geladen',
    'wishlist.emptyTitle': 'Du hast noch keine Favoriten',
    'wishlist.emptyText': 'Klicke auf das ❤️-Symbol auf der Produktkarte, um deine Favoriten zu speichern!',
    'wishlist.backToProducts': 'Zurück zu den Produkten',

    'nf.title': 'Diese Seite wurde nicht gefunden',
    'nf.text': 'Vielleicht hast du dich bei der Adresse vertippt, oder das gesuchte Produkt ist nicht mehr verfügbar. Unser komplettes Sortiment — über 1.800 Arbeitsschutzprodukte — ist nur einen Klick entfernt.',
    'nf.backShop': 'Zurück zum Shop',
    'nf.browseCategories': 'Kategorien durchsuchen',
    'nf.helpText': 'Können wir dir helfen, das zu finden, was du suchst?',

    'blog.heading': 'Experten-Blog',
    'blog.subtitle': 'Ratgeber, Normerklärungen und Kauftipps — damit du genau das bekommst, was du wirklich brauchst.',
    'blog.allCount': 'Alle ({n})',
    'blog.noResults': 'Keine Artikel entsprechen diesem Filter.',
    'blog.latest': 'Neueste',
    'blog.min': 'Min.',
    'blog.webshop': 'Shop',
    'blog.summary': 'Kurz gesagt:',
    'blog.recoTitle': 'Passend zum Artikel',
    'blog.recoSubtitle': 'Eine Auswahl aus unserem Shop — zu Preisen unter dem Listenpreis.',
    'blog.toShop': 'Weiter zum Shop',
    'blog.relatedArticles': 'Verwandte Artikel',
    'blog.authorBio': 'TridentShop ist der Onlineshop der Trident Shield Group Kft. — Arbeitsschutzexperten wählen die Produkte aus und schreiben die Ratgeber. Hast du eine Frage? Ruf an:',

    'faq.heading': 'Häufig gestellte Fragen',
    'faq.subtitle': 'Wir haben die häufigsten Fragen zu Bestellung, Versand und der Auswahl von Arbeitsschutzprodukten zusammengestellt.',
    'faq.helpTitle': 'Findest du die Antwort nicht?',
    'faq.q1': 'Wie lange dauert der Versand und was kostet er?',
    'faq.a1': 'Wir liefern deine Bestellung landesweit innerhalb von 2-3 Werktagen per Kurier (1.290 Ft) oder innerhalb von 2-4 Werktagen an einen Foxpost-Paketautomaten (990 Ft). Ab einem Bestellwert von 30.000 Ft ist die Lieferung in beiden Fällen kostenlos.',
    'faq.q2': 'Welche Sicherheitsschuh-Kategorie soll ich wählen (S1, S1P, S2, S3)?',
    'faq.a2': 'S1 eignet sich für trockene Innenräume (Zehenschutzkappe + antistatische Sohle). S1P enthält zusätzlich eine durchtrittsichere Zwischensohle — für Werkstatt und Baustelle. S2 bietet ein wasserabweisendes Obermaterial, S3 vereint alles: wasserabweisend, durchtrittsicher, profilierte Sohle — für Außen- und Industriearbeit empfehlen wir diese Kategorie. Einen ausführlichen Ratgeber findest du in unserem Blog.',
    'faq.q3': 'Wer bezahlt die persönliche Schutzausrüstung: der Arbeitgeber oder der Arbeitnehmer?',
    'faq.a3': 'Nach dem ungarischen Arbeitsschutzgesetz ist der Arbeitgeber verpflichtet, persönliche Schutzausrüstung auf eigene Kosten bereitzustellen. Seit 2024 muss die Regelung zur Ausgabe von Schutzausrüstung schriftlich je Tätigkeit festgehalten werden. Unser Unternehmen, die Trident Shield Group Kft., unterstützt dabei auch als Dienstleistung.',
    'faq.q4': 'Wie wähle ich die richtige Größe?',
    'faq.a4': 'Bei Schuhen wähle deine gewohnte Straßenschuhgröße; für Winterschuhe mit dicken Socken eine halbe Nummer größer. Bei Bekleidung verwendet Portwest die europäische Größentabelle (S-4XL) — im Zweifel empfehlen wir die größere der auf der Produktseite verfügbaren Größen. Passt die Größe nicht, tauschen wir sie um.',
    'faq.q5': 'Kann ich ein Produkt zurückgeben oder umtauschen?',
    'faq.a5': 'Ja, gemäß den geltenden Verbraucherschutzbestimmungen kannst du innerhalb von 14 Tagen ohne Angabe von Gründen vom Kauf zurücktreten; wir tauschen das Produkt um oder erstatten den Kaufpreis. Details findest du in unseren AGB.',
    'faq.q6': 'Erhalte ich eine Rechnung für meine Bestellung?',
    'faq.a6': 'Ja, wir stellen für jede Bestellung eine Rechnung mit ausgewiesener Umsatzsteuer aus (für Firmen mit Firmendaten), die wir zusammen mit der Bestellbestätigung versenden.',
    'faq.q7': 'Kann ich auch größere Mengen als Firmenbeschaffung bestellen?',
    'faq.a7': 'Natürlich — wir bedienen auch Firmen- und Institutionsbestellungen und erstellen bei größeren Mengen ein individuelles Angebot. Schreib an iroda@tuz-munkavedelmiszaki.hu oder ruf +36 30 272 2571 an.',
    'faq.q8': 'Verkauft ihr Original-Portwest-Produkte?',
    'faq.a8': 'Ja, wir verkaufen ausschließlich originale, CE-zertifizierte Portwest-Produkte mit offiziellem ungarischem Vertriebshintergrund. Jedes Produkt entspricht den relevanten EU-Normen (z. B. EN ISO 20345 für Schuhe, EN 388 für Handschuhe, EN ISO 20471 für Warnschutzkleidung, EN 397 für Helme).',
    'faq.q9': 'Wo befindet sich euer Geschäft?',
    'faq.a9': 'Unser Hauptsitz: 4030 Debrecen, Keleti Ipartelep utca 4, Ungarn. Von unserem Webshop aus liefern wir landesweit. Öffnungszeiten: Montag-Freitag 8:00-17:00 Uhr.',
    'faq.q10': 'Bietet ihr auch Arbeitsschutz-Dienstleistungen an?',
    'faq.a10': 'Ja — die Trident Shield Group Kft. (MunkavédelmiSzaki) bietet umfassende Arbeits- und Brandschutzdienstleistungen: Risikobewertungen, Arbeitsschutzschulungen, Brandschutzordnungen und die Erstellung von Regelungen zur Ausgabe persönlicher Schutzausrüstung für ungarische KMU.'
  },

  zh: {
    'nav.all': '全部',
    'nav.blog': '博客',
    'nav.favorites': '收藏',
    'nav.cart': '购物车',
    'nav.search': '按名称或货号搜索…',
    'nav.freeShipping': '满 30,000 福林免运费',

    'hero.title': '你的工作保护我们，我们保护你。',
    'hero.subtitle': '正品 Portwest 工作服与防护装备，现货供应，全国配送。',
    'hero.ctaDeals': '特价商品',
    'hero.ctaCategories': '商品分类',

    'section.deals': '特价商品',
    'section.belowList': '低于标价',
    'section.categories': '您在找什么？',
    'section.products': '件商品',
    'section.loadMore': '加载更多',

    'filter.title': '筛选',
    'filter.price': '价格',
    'filter.brand': '品牌',
    'filter.size': '尺码',
    'filter.rating': '评分',
    'filter.reset': '重置筛选',
    'filter.sort': '排序',
    'filter.sortDefault': '默认',
    'filter.sortPriceAsc': '价格：从低到高',
    'filter.sortPriceDesc': '价格：从高到低',
    'filter.sortName': '按名称',
    'filter.sortRating': '按评分',

    'product.addToCart': '加入购物车',
    'product.inStock': '有货',
    'product.outOfStock': '缺货',
    'product.size': '尺码',
    'product.color': '颜色',
    'product.quantity': '数量',
    'product.sizeChart': '尺码表',
    'product.related': '相关商品',
    'product.brand': '品牌',

    'cart.title': '购物车',
    'cart.empty': '购物车是空的',
    'cart.subtotal': '小计',
    'cart.shipping': '运费',
    'cart.total': '合计',
    'cart.checkout': '结算',
    'cart.free': '免费',

    'checkout.title': '结算',
    'checkout.summary': '订单摘要',
    'checkout.shippingData': '收货信息',
    'checkout.name': '姓名',
    'checkout.email': '电子邮箱',
    'checkout.phone': '电话',
    'checkout.company': '公司',
    'checkout.address': '收货地址',
    'checkout.city': '城市',
    'checkout.zip': '邮政编码',
    'checkout.shippingMethod': '配送方式',
    'checkout.homeDelivery': '送货上门',
    'checkout.paymentMethod': '支付方式',
    'checkout.cod': '货到付款',
    'checkout.transfer': '银行转账',
    'checkout.card': '银行卡支付',
    'checkout.coupon': '优惠码',
    'checkout.apply': '使用',
    'checkout.submit': '提交订单',

    'account.title': '我的账户',
    'account.login': '登录',
    'account.register': '注册',
    'account.logout': '退出登录',
    'account.myOrders': '我的订单',
    'account.password': '密码',

    'tracking.title': '订单查询',
    'tracking.orderId': '订单号',
    'tracking.lookup': '查询订单',

    'footer.categories': '商品分类',
    'footer.info': '信息',
    'footer.faq': '常见问题',
    'footer.tracking': '订单查询',
    'footer.account': '我的账户',
    'footer.about': '关于我们',
    'footer.shipping': '配送说明',
    'footer.terms': '条款与条件',
    'footer.privacy': '隐私政策',
    'footer.impressum': '公司信息',
    'footer.contact': '联系我们',
    'footer.newsletter': '订阅通讯',
    'footer.subscribe': '订阅',

    'common.back': '返回商店',
    'common.loading': '加载中…',
    'common.close': '关闭',
    'common.productsInHungarian': '商品描述为匈牙利语。',

    'cat.munkaruha': '工作服',
    'cat.munkacipo': '安全鞋',
    'cat.bakancs': '安全靴与胶靴',
    'cat.kesztyu': '防护手套',
    'cat.kiegeszitok': '防护装备',

    'sub.nadragok': '工作裤',
    'sub.felsok': 'T恤、衬衫',
    'sub.puloverek': '卫衣与毛衣',
    'sub.kabatok': '外套与夹克',
    'sub.lathatosagi': '高可视工作服',
    'sub.overalok': '连体工作服',
    'sub.langallo': '阻燃工作服',
    'sub.esd-ruhazat': 'ESD 防静电工作服',
    'sub.eso-elleni': '防雨服',
    'sub.hutohazi': '冷库工作服',
    'sub.ipari-vedoruha': '工业防护服',
    'sub.kopeny-tunika': '罩衣与制服',
    'sub.elelmiszeripari': '食品行业工作服',
    'sub.egyszer-hasznalatos': '一次性防护服',
    'sub.sef-ruhazat': '厨师服',
    'sub.gyermek': '儿童服装',
    'sub.cipo-s1': 'S1 / S1P 类别',
    'sub.cipo-s2s3': 'S2 / S3 类别',
    'sub.szandal-papucs': '凉鞋与工作拖鞋',
    'sub.zokni-talpbetet': '袜子与鞋垫',
    'sub.bakancs-s1p': 'S1P 安全靴',
    'sub.bakancs-s3': 'S3 安全靴',
    'sub.bakancs-teli': '冬季安全靴',
    'sub.csizmak': '胶靴',
    'sub.kesztyu-mechanikai': '机械防护手套',
    'sub.kesztyu-vagasbiztos': '防割手套',
    'sub.kesztyu-hideg': '防寒手套',
    'sub.sisakok': '安全帽',
    'sub.arcvedok': '面罩',
    'sub.sapkak': '防撞帽',
    'sub.szemuvegek': '防护眼镜',
    'sub.gumipantos-szemuvegek': '护目镜',
    'sub.mellenyek': '反光背心',
    'sub.fultokok': '耳罩',
    'sub.fuldugok': '耳塞',
    'sub.legzesvedok': '呼吸防护与滤件',
    'sub.terdvedok': '护膝',
    'sub.magasban-munka': '高空作业',
    'sub.zuhanasgatlo-kieg': '防坠落配件',
    'sub.taskak': '包袋与配件',

    'nav.home': '首页',
    'badge.sale': '特价',
    'badge.last': '仅剩 {n} 件！',
    'chip.winter': '冬季',
    'chip.springAutumn': '春秋',
    'chip.summer': '夏季',
    'chip.multiColor': '多色可选',
    'chip.bigSizes': '提供大码',
    'product.stockLine': '有货 · 2-3 个工作日',
    'product.addWish': '加入收藏',
    'product.removeWish': '取消收藏',
    'product.inStockCount': '库存：{n} 件',
    'product.allSizesOut': '该颜色所有尺码均已售罄。',
    'product.fullPage': '查看商品详情',
    'alert.chooseSize': '请选择尺码！',
    'alert.chooseColor': '请选择颜色！',
    'alert.validEmail': '请输入有效的电子邮箱。',
    'hero.saleKicker': '特价',
    'hero.upTo': '低至 −{p}%',
    'hero.discountWord': '优惠。',
    'hero.saleText': '{name} — 现价 {price} 福林，售完即止。',
    'hero.saleCta': '查看特价',
    'hero.bogoTitle1': '买二',
    'hero.bogoTitle2': '付一。',
    'hero.bogoText': '手套、耳塞、护目镜和口罩——第二件真正免费。',
    'hero.bogoCta': '1+1 优惠',
    'hero.shipKicker': '配送',
    'hero.shipTitle1': '满 30,000 福林',
    'hero.shipTitle2': '免运费。',
    'hero.shipText': '100% Portwest 正品，CE 认证，14 天换货退货。',
    'section.dealsKicker': '现在',
    'section.dealsSub': '精选折扣，售完即止。',
    'section.moreProducts': '件更多商品',
    'mission.title': '假货不防护。',
    'mission.sub': '我们绝无仿品——正品且通过 CE 认证。',
    'bogo.kicker': '两件半价',
    'bogo.title': '我们的 1+1 优惠',
    'bogo.sub': '买二付一——购物车和发票中的折扣真实有效。',
    'bogo.perPcNormal': '福林/件（正常价）',
    'bogo.perPcDeal': '/件（1+1）',
    'bogo.addTwo': '2 件加入购物车',
    'noResults.title': '未找到商品',
    'noResults.text': '请尝试其他筛选条件或重置筛选。',
    'filter.show': '显示筛选',
    'filter.hide': '隐藏筛选',
    'filter.industry': '行业',
    'filter.standard': '标准',
    'filter.all': '全部',
    'trust.ship': '快速配送',
    'trust.shipText': '全国 2-3 个工作日送达',
    'trust.quality': '品质保证',
    'trust.qualityText': '欧盟认证产品',
    'trust.expert': '专业咨询',
    'trust.expertText': '专家帮您选择',
    'trust.support': '客户服务',
    'blog.kicker': '专业内容',
    'blog.title': '实用文章',
    'blog.all': '全部文章 →',
    'blog.read': '阅读全文 →',
    'blog.minRead': '分钟阅读',
    'blog.defaultTag': '专业知识',
    'news.heading': '订阅我们，帮您做出完美选择！',
    'news.b1': '第一时间获取最新优惠',
    'news.b2': '季节性优惠与购买建议一站获取',
    'news.b3': '每月最多 2 封邮件，可随时退订',
    'news.emailPh': '您的邮箱',
    'footer.desc': '劳保服装、鞋类及装备，直接从仓库发货。',
    'footer.blog': '博客',
    'footer.wishlist': '我的收藏',
    'footer.rights': '版权所有',
    'pdp.reviews': '评价',
    'pdp.reviewSummary': '评分摘要',
    'pdp.clickToFilter': '点击行进行筛选。',
    'pdp.stars': '{n} 星',
    'pdp.overallRating': '总体评分',
    'pdp.noReviews': '暂无评价——来做第一个吧！',
    'pdp.rateProduct': '为商品评分',
    'pdp.moderated': '评价经审核后显示。',
    'pdp.writeReview': '写下您的评价',
    'pdp.yourName': '您的姓名',
    'pdp.reviewPh': '商品如何？尺码、舒适度、耐用性……',
    'pdp.submitReview': '提交评价',
    'pdp.chooseColor': '选择颜色',
    'pdp.chooseSize': '选择尺码',
    'pdp.shipBoxTitle': '配送、换货与退货',
    'pdp.shipInfo1': '全国 2-3 个工作日送达，满 30,000 福林免运费。',
    'pdp.shipInfo2': '14 天内可无理由换货或退货。',
    'pdp.trust1': '2-3 个工作日快速送达',
    'pdp.trust2': '欧盟认证产品',
    'pdp.trust3': '14 天退款保证',

    'cart.bundleLine': '1+1 优惠——第二件免费',
    'cart.freePcs': '（{n} 件免费）',
    'nav.allCat': '全部{name} →',
    'filter.subcategories': '子类别',
    'tile.kabatok': '外套',
    'tile.polok': 'T恤',
    'tile.nadragok': '裤装',
    'tile.cipok': '安全鞋',
    'tile.bakancsok': '安全靴',
    'tile.kesztyuk': '防护手套',
    'tile.vedoeszkozok': '防护装备',
    'tile.egyebek': '其他',
    'ind.food': '食品行业',
    'ind.esd': 'ESD 与电子',
    'ind.cold': '冷库与冷藏',
    'ind.industrial': '工业防护',
    'ind.welding': '焊接与消防',
    'ind.hospitality': '餐饮与厨师',
    'ind.height': '高空作业',
    'ind.construction': '建筑与道路施工',
    'news.done': '订阅成功，谢谢！',
    'hero.t1': '你的工作保护我们。',
    'hero.t2': '我们保护你。',
    'hero.countText': '{n}+ 件 Portwest 正品工作服、安全鞋及装备。',
    'alert.sizeOut': '{color} 颜色 {size} 尺码已售罄！',
    'alert.sizeOnly': '{color} / {size} 尺码仅剩 {n} 件！',
    'pdp.reviewWord': '条评价',
    'pdp.inWishlist': '已收藏',
    'pdp.sortTop': '好评优先',
    'pdp.sortNew': '最新优先',
    'pdp.noFilteredReviews': '没有符合筛选的评价。',
    'pdp.reviewThanks': '谢谢！您的评价将在审核后显示。',
    'pdp.reviewMissing': '请填写您的姓名和评价！',

    'checkout.emptyTitle': '购物车是空的！',
    'checkout.emptyText': '请先将商品加入购物车才能下单。',
    'checkout.backToCatalog': '返回商品目录',
    'checkout.successTitle': '订单已成功提交！',
    'checkout.successText1': '感谢您的订购！订单详情已发送至 {email}。',
    'checkout.successText2': '我们会尽快与您联系。',
    'checkout.backHome': '返回首页',
    'checkout.couponPlaceholder': '例如 SUMMER10',
    'checkout.remove': '移除',
    'checkout.couponApplied': '优惠码 {code} 已使用',
    'checkout.productsTotal': '商品总计：',
    'checkout.couponDiscount': '优惠码折扣（{code}）：',
    'checkout.grandTotal': '总计：',
    'checkout.namePlaceholder': '您的全名',
    'checkout.emailPlaceholder': 'email@example.com',
    'checkout.marketingConsent': '我订阅新闻通讯（优惠、优惠码——每月最多 2 封邮件），并希望在我放弃购物车时收到提醒。可随时取消订阅。',
    'checkout.phonePlaceholder': '+36 30 123 4567',
    'checkout.companyPlaceholder': '公司名称（可选）',
    'checkout.addressPlaceholder': '街道、门牌号',
    'checkout.cityPlaceholder': '城市',
    'checkout.zipPlaceholder': '1000',
    'checkout.homeDeliveryDays': '2-3 个工作日',
    'checkout.foxpost': 'Foxpost 自助取件柜',
    'checkout.foxpostDays': '2-4 个工作日',
    'checkout.foxpostLoadingList': '（正在加载列表…）',
    'checkout.foxpostChange': '修改',
    'checkout.foxpostSearchPlaceholder': '按城市或邮政编码搜索…',
    'checkout.codDesc': '快递员/自助柜处现金或刷卡付款',
    'checkout.transferDesc': '转账信息将在确认邮件中发送',
    'checkout.cardDesc': '通过 SimplePay 即时安全支付',
    'checkout.transferNote': '款项到账后我们将发货。',
    'checkout.cardNote': '点击"提交订单"后，您将被跳转至 SimplePay 安全支付页面。本商城不会看到或存储您的银行卡信息。',
    'checkout.notesLabel': '备注（可选）',
    'checkout.notesPlaceholder': '特殊说明、需求……',
    'checkout.submitting': '处理中……',
    'checkout.paymentNote': '付款：下单后我们会通过邮件发送付款信息。',
    'checkout.errRequired': '请填写所有必填字段！',
    'checkout.errEmptyCart': '购物车是空的！',
    'checkout.errFoxpost': '请选择 Foxpost 自助取件柜！',
    'checkout.errGeneric': '处理订单时发生错误，请稍后重试！',
    'checkout.errCardFailed': '无法启动银行卡支付。您的订单已记录——我们会通过邮件发送转账信息。',
    'checkout.errCoupon': '优惠码无效',
    'checkout.errCouponCheck': '优惠码校验出错，请重试！',

    'account.notAvailable': '客户账户功能目前不可用。',
    'account.noOrders': '此邮箱地址暂无订单。',
    'account.goToShop': '前往商店',
    'account.invoiceLabel': '发票',
    'account.trackingLabel': '快递单号',
    'account.invoiceNote': '每笔订单的发票都会通过邮件发送。如果找不到，请发送邮件至 {email}。',
    'account.resetHeading': '忘记密码',
    'account.loginSubtitle': '登录以查看您之前的订单。',
    'account.registerSubtitle': '创建账户以跟踪您的订单和发票。',
    'account.resetSubtitle': '输入您的邮箱地址，我们将发送密码重置链接。',
    'account.name': '姓名',
    'account.namePlaceholder': '您的全名',
    'account.email': '电子邮箱',
    'account.emailPlaceholder': 'email@example.com',
    'account.passwordPlaceholder': '至少 6 个字符',
    'account.working': '处理中…',
    'account.submitRegister': '创建账户',
    'account.submitReset': '请求重置链接',
    'account.noAccountYet': '我还没有账户',
    'account.forgotPassword': '我忘记了密码',
    'account.backToLogin': '返回登录',
    'account.guestNote1': '您也可以不注册账户直接购物。您还可以在',
    'account.guestNoteLink': '订单查询页面',
    'account.guestNote2': '查看订单状态。',
    'account.registerSuccess': '注册成功！如果您收到了确认邮件，请点击邮件中的链接。',
    'account.resetSuccess': '密码重置邮件已发送，请查收！',
    'account.genericError': '发生错误。',
    'account.loadError': '加载错误',

    'status.pending': '处理中',
    'status.paid': '已付款',
    'status.packed': '已打包',
    'status.shipped': '运输中',
    'status.delivered': '已送达',
    'status.cancelled': '已取消',

    'tracking.subtitle': '请输入订单号（可在确认邮件中找到）和您下单时使用的邮箱地址。',
    'tracking.emailLabel': '电子邮箱',
    'tracking.orderIdPlaceholder': '例如 ORD-1784992520497',
    'tracking.emailPlaceholder': 'email@example.com',
    'tracking.searching': '查询中…',
    'tracking.errRequired': '请输入订单号和邮箱地址。',
    'tracking.errNotFound': '无法获取该订单信息。',
    'tracking.errNetwork': '网络错误，请检查网络连接后重试。',
    'tracking.cancelled': '此订单已被取消。',
    'tracking.total': '总金额',
    'tracking.trackingNumber': '快递单号：',
    'tracking.trackingNote': '您也可以使用此单号在快递公司网站上追踪包裹。',
    'tracking.items': '商品明细',
    'tracking.shippingLabel': '配送方式：',
    'tracking.paymentLabel': '付款方式：',
    'tracking.invoiceLabel': '发票号：',
    'tracking.foxpost': 'Foxpost 自助取件柜',
    'tracking.helpTitle': '找不到您的订单？',
    'tracking.step.pending': '已接收',
    'tracking.step.paid': '已付款',
    'tracking.step.packed': '已打包',
    'tracking.step.shipped': '已发货',
    'tracking.step.delivered': '已送达',

    'common.callUs': '联系电话：',

    'wishlist.count': '已保存 {n} 件商品',
    'wishlist.cloudTitle': '将收藏保存到邮箱地址——可在任何设备上访问',
    'wishlist.cloudSubtitle': '该列表由您设置的 PIN 码保护，使用相同的 PIN 码即可重新加载。',
    'wishlist.emailPlaceholder': 'you@example.com',
    'wishlist.pinPlaceholder': 'PIN 码（4-8 位数字）',
    'wishlist.save': '保存',
    'wishlist.load': '加载',
    'wishlist.errEmail': '请输入有效的邮箱地址！',
    'wishlist.errPin': '请输入 4-8 位的 PIN 码——用于保护您的列表。',
    'wishlist.errGeneric': '发生错误，请重试！',
    'wishlist.savedMsg': '已保存 {n} 件收藏。请记住您的 PIN 码——用于重新加载！',
    'wishlist.loadedMsg': '已加载 {n} 件收藏',
    'wishlist.emptyTitle': '您还没有收藏商品',
    'wishlist.emptyText': '点击商品卡片上的 ❤️ 图标即可收藏！',
    'wishlist.backToProducts': '返回商品列表',

    'nf.title': '找不到此页面',
    'nf.text': '您可能输错了网址，或者所查找的商品已下架。我们的全部商品——超过 1800 种劳保用品——只需一键即可浏览。',
    'nf.backShop': '返回商店',
    'nf.browseCategories': '浏览商品分类',
    'nf.helpText': '需要我们帮您找到所需商品吗？',

    'blog.heading': '专家博客',
    'blog.subtitle': '指南、标准解读与购买建议——助您精准选购真正需要的产品。',
    'blog.allCount': '全部（{n}）',
    'blog.noResults': '没有符合筛选条件的文章。',
    'blog.latest': '最新',
    'blog.min': '分钟',
    'blog.webshop': '商店',
    'blog.summary': '简要：',
    'blog.recoTitle': '本文推荐商品',
    'blog.recoSubtitle': '精选自本商店——价格低于标价。',
    'blog.toShop': '前往商店',
    'blog.relatedArticles': '相关文章',
    'blog.authorBio': 'TridentShop 是 Trident Shield Group Kft. 旗下的网店——由劳动安全专家精选商品并撰写指南。有疑问？请致电：',

    'faq.heading': '常见问题',
    'faq.subtitle': '我们整理了关于下单、配送以及劳保产品选购方面的常见问题。',
    'faq.helpTitle': '没有找到答案？',
    'faq.q1': '配送需要多长时间？运费是多少？',
    'faq.a1': '全国范围内，快递配送 2-3 个工作日送达（运费 1,290 福林），或 2-4 个工作日送达 Foxpost 自助取件柜（运费 990 福林）。订单满 30,000 福林，两种配送方式均免运费。',
    'faq.q2': '应该选择哪种安全鞋类别（S1、S1P、S2、S3）？',
    'faq.a2': 'S1 适合室内干燥环境（带包头+防静电鞋底）。S1P 还带有防刺穿中底——适合车间和工地。S2 增加了防水鞋面，S3 则集所有功能于一身：防水、防刺穿、花纹鞋底——推荐用于户外及工业作业。详细指南请见我们的博客。',
    'faq.q3': '个人防护装备的费用由谁承担：雇主还是员工？',
    'faq.a3': '根据劳动安全法规，雇主必须自费提供个人防护装备。自 2024 年起，防护装备发放制度须按岗位以书面形式记录。我们公司 Trident Shield Group Kft. 也提供此项服务协助。',
    'faq.q4': '如何选择合适的尺码？',
    'faq.a4': '鞋类请选择您平时的日常鞋码；冬季搭配厚袜子建议选大半码。服装方面 Portwest 采用欧码（S-4XL）——如有疑问，建议在商品页面提供的尺码中选择偏大的一个。如尺码不合适，我们支持换货。',
    'faq.q5': '可以退货或换货吗？',
    'faq.a5': '可以，根据现行消费者保护法规，您可在 14 天内无需说明理由撤销购买，我们将为您换货或退款。详情请参见我们的条款与条件。',
    'faq.q6': '订单会开具发票吗？',
    'faq.a6': '会的，我们为每笔订单开具增值税发票（企业客户可提供公司信息），发票将随订单确认一并发送。',
    'faq.q7': '可以进行大批量企业采购吗？',
    'faq.a7': '当然可以——我们也承接企业及机构订单，大批量订购可提供专属报价。请发送邮件至 iroda@tuz-munkavedelmiszaki.hu 或致电 +36 30 272 2571。',
    'faq.q8': '你们销售的是正品 Portwest 产品吗？',
    'faq.a8': '是的，我们只销售正品、通过 CE 认证的 Portwest 产品，并有匈牙利官方供应商背景支持。所有产品均符合相关欧盟标准（如鞋类 EN ISO 20345、手套 EN 388、高可视服装 EN ISO 20471、头盔 EN 397）。',
    'faq.q9': '你们的门店在哪里？',
    'faq.a9': '我们的总部位于匈牙利 4030 Debrecen, Keleti Ipartelep utca 4。我们通过网店向全国配送。营业时间：周一至周五 8:00-17:00。',
    'faq.q10': '你们也提供劳动安全相关服务吗？',
    'faq.a10': '是的——Trident Shield Group Kft.（MunkavédelmiSzaki）为匈牙利中小企业提供全面的劳动安全与消防服务：风险评估、安全培训、消防管理制度及个人防护装备发放制度制定。'
  }
};
